/*
 * サブシステム名：受注
 * 機能名：受付入力
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdFooterButton from '@/components/DdFooterButton'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import modals from '@/ddv2.library/modals'
import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'
import { ArrayFilter } from '@/rahmen/arrayFilter'
import flowMixin from '@/mixins/flowMixins'
import formatter from '@/ddv2.library/utils/formatter'
import tax from '@/ddv2.library/tax'

import { mapGetters } from 'vuex'
import YubinBango from 'yubinbango-core2'

const DdCheckbox = () => import('@/components2/DdCheckbox')
const DdCodeTextBox = () => import('@/components2/DdCodeTextBox')
const DdDateBox = () => import('@/components2/DdDateBox')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components2/DdNumericBox')
const DdTextArea = () => import('@/components2/DdTextArea')
const DdTextBox = () => import('@/components2/DdTextBox')
const DdTextBoxPlaceHolderFree = () => import('@/components/DdTextBoxPlaceHolderFree')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSubTitle = () => import('@/components/DdSubTitle')
const DdSwitch = () => import('@/components/DdSwitch')

const SP_TORITSUKESAKI_1 = '新開トランスポート'

export default {
  name: 'uketsuke-entry',
  mixins: [flowMixin],
  components: {
    DdCheckbox,
    DdCodeTextBox,
    DdCustomButton,
    DdDateBox,
    DdFooterButton,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdSubTitle,
    DdSubHeader,
    DdSwitch,
    DdTextArea,
    DdTextBox,
    DdTextBoxPlaceHolderFree
  },
  data: () => ({
    id: 0,
    juchuKihonId: 0,

    backActionNo: 0,
    Filters: new ArrayFilter([]),

    // ページネーション用
    vitemsPerPage: 0,
    vPage: 1,

    // ヘッダー定義
    headersHinmeiList: header.mstHinmeiHeaders,
    headersJininList: header.mstJininHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersJenreList: header.mstTgJenreHeaders,

    // バインド定義
    rec: {
      trJuchuKihon: {},
      trJuchuMeisai: {},
      trJuchuHinmoku: [],
      trSagyoMeisai: {},
      trSagyoHinmoku: [],
      trSagyoSharyoList: [],
      trSagyoSharyoHimokuList: [],
      vwCTgrcod002080: [],
      vwCTgrcod002080Receipt: [],
      vwCTgrcod002081: [],
      sagyoNaiyoKakuteiChangeFlg: false,
      seikyuKakuteiChangeFlg: false
    },
    rows: {
      signalItems: [],
      kihonSagyoRows: [],
      optionSagyoRows: [],
      sagyoBuzaiRows: [],
      sharyoRows: [],
      sharyoKihonRows: [],
      sharyoOptionRows: [],
      sharyoBuzaiRows: [],
      hassoDenpyoRows: [],
      hassoDenpyoBuzaiRows: [],
      sagyoIraiRows: []
    },
    seikyuSagyoKingakuKei: 0,
    seikyuBuzaiKingakuKei: 0,
    seikyuChoseiKomiKingakuKei: 0,
    shiharaiKingakuKei: 0,
    mitsumoriIraiDaisu: 0,
    kihonSagyoSeikyuKingaku: 0,
    kihonSagyoShiharaiKingaku: 0,
    sharyoDaisu: 0,
    cloneSagyoNaiyoKakuteiFlg: false,
    cloneSeikyuKakuteiFlg: false,
    seikyuRankChangeFlg: false,
    sharyoTorikomiFile: null,
    filterSharyoSagyoMikanryoFlg: false,
    filterSharyoUriageMikakuteiFlg: false,
    filterSharyoCancelFlg: false,
    orderStopFlg: false,

    sharyoSearchText: '',

    // 住所保存用
    savedToritsukeYubinNo: null,
    savedToritsukeJusho1: null,
    savedToritsukeJusho2: null,
    savedToritsukeJusho3: null,

    // 請求支払金額保存用
    savedSeikyuKingaku: null,
    savedShiharaiKingaku: null,

    pastUketsukeSearchItem: {
      tokuisakiId: null,
      toritsukesakiNm: null
    },
    // --------------------------------------------------------------------------------
    // 車両
    // --------------------------------------------------------------------------------
    sagyoSharyoListParam: {
      jishaDenpyoNo: null,
      tokuisakiId: null,
      toritsukesakiNm: null,
      eigyosho: null,
      rownum: 0
    },
    sharyoId: 0,
    recSharyo: {},
    sharyoParam: {
      shohinId: null,
      denpyoHanyoSbt2: null,
      unchinKakuteiFlg: false,
      seikyuRank: null,
      uketsukeSagyoList: [],
      uketsukeBuzaiList: [],
      index: null
    },
    // --------------------------------------------------------------------------------
    // 発送伝票
    // --------------------------------------------------------------------------------
    hassoDenpyoId: 0,
    hassoDenpyoParam: {
      nohinbashoYubinNo: null,
      nohinbashoJusho1: null,
      nohinbashoJusho2: null,
      nohinbashoJusho3: null,
      denpyoBiko2: null,
      denpyoBiko3: null,
      denpyoBiko5: null,
      toritsukesakiNm: null,
      unchinKakuteiFlg: false,
      seikyuRank: null,
      hassoDenpyoBuzaiRows: []
    },
    hassoBuzaiListParam: [],
    // --------------------------------------------------------------------------------
    // 作業依頼
    // --------------------------------------------------------------------------------
    sagyoIraiId: 0,
    iraiMailId: 0,
    sagyoIraiParam: {
      sagyobashoYubinNo: null,
      sagyobashoJusho1: null,
      sagyobashoJusho2: null,
      sagyobashoJusho3: null,
      sagyoKbnNm: null,
      hatsuchiYmd: null,
      chakuchiYmd: null,
      toritsukesakiNm: null,
      unchinKakuteiFlg: false,
      seikyuRank: null,
      uketsukeSagyoList: [],
      uketsukeBuzaiList: [],
      tokuisakiNm: null
    },
    seletedSharyoList: [],

    modeOfEdit: 2,
    modeKengen: 2,

    isAnkerLinkDisp: false,
    isLoading: false,
    isOptionLoading: false,
    isBuzaiLoading: false,
    isSaving: false,
    isCheckSheetDownload: false,
    isReceiptDownload: false,
    isPictureDownload: false,
    isShowPastUketsukeSearchDialog: false,
    isShowPopupSagyoKihon: false,
    isShowPopupOptionSagyo: false,
    isShowPopupBuzai: false,
    isShowPopupSagyoSharyoList: false,
    isShowPopupSagyoSharyoEdit: false,
    isShowToritsukesakiSearchDialog: false,
    isShowSagyobashoSearchDialog: false,
    isShowPopuoBuzaiHassoEdit: false,
    isShowPopupSagyoIraiEdit: false

  }),
  watch: {
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      jininList: 'DDMasters/mstJinin',
      hinmeiList: 'DDMasters/mstHinmei',
      addressList: 'DDMasters/mstAddress',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      tgMstHinmeiList: 'DDMasters/vwCMstHinmeiExtTg',
      jenreList: 'DDMasters/mstTgJenre',
      currentKinoId: 'system/currentKinoId',
      loginUserId: 'users/userId',
      helpUseFlg: 'DDMasters/helpUseFlg',
      statusChangeDialogFlg: 'DDMasters/statusChangeDialogFlg',
      currentKaishaCode: 'users/currentKaishaCode'
    }),

    // ----------------------------------------------------------------------------------------------------
    // ヘッダー定義
    // ----------------------------------------------------------------------------------------------------
    filteredSagyoHeaders () {
      return [
        { text: '作業名称', value: 'hinmeiNm' },
        // { text: '品番', value: 'hinban' },
        // { text: '型式', value: 'katashiki' },
        { text: '作業数', value: 'juchuSuryo', align: 'center', width: '75px' },
        // { text: '単位', value: 'tani' },
        // { text: '標準単価', value: 'hyojunTankaDisp', align: 'end', width: '10%' },
        // { text: '標準価格', value: 'hyojunKingakuDisp', align: 'end', width: '10%' },
        { text: '請求単価', value: 'shohinTankaDisp', align: 'center', width: '120px' },
        { text: '請求金額', value: 'seikyuKingaku', align: 'center', width: '120px' }
      ]
    },
    filteredSharyoHeaders () {
      return [
        { text: '', value: 'jissekiMikakuninFlg', class: 'px-0', align: 'center', sortable: false },
        { text: '#', value: 'keyNo', class: 'px-1', align: 'end', sortable: false },
        { text: '操作', value: 'actions', class: 'px-0', align: 'center', sortable: false, width: '70px' },
        { text: '作業完了', value: 'sagyoKanryoStatus', class: 'px-0', align: 'center', sortable: false, width: '55px' },
        { text: '売上確定', value: 'uriageKakuteiStatus', class: 'px-0', align: 'center', sortable: false, width: '55px' },
        { text: '請求種別', value: 'seikyuSbt', class: 'px-0', align: 'center', sortable: false, width: '55px' },
        { text: 'OPSアップロード未完', value: 'notOpsUploadStatus', class: 'px-0', align: 'center', sortable: false, width: '55px' },
        { text: '売上締め', value: 'uriageClosingStatus', class: 'px-0', align: 'center', sortable: false, width: '45px' },
        { text: '支払締め', value: 'shiharaiClosingStatus', class: 'px-0', align: 'center', sortable: false, width: '45px' },
        { text: '作業依頼先', value: 'iraisakiNm' },
        { text: '作業予定日', value: 'sagyoYoteiYmdDisp', align: 'center', class: '' },
        { text: '作業実施日', value: 'jissekiSagyoYmdDisp', align: 'center', class: '' },
        { text: '作業実施者', value: 'sagyoJisshishaNm', class: '' },
        { text: '車番プレートNo', value: 'newShabanPlateNo', class: '' },
        // { text: '旧車番プレートNo', value: 'oldShabanPlateNo', class: '' },
        // { text: '新車台番号', value: 'newShadaiNo', class: '' },
        // { text: '旧車台番号', value: 'oldShadaiNo', class: '' },
        // { text: '車両型式', value: 'sharyoKeishiki', class: '' },
        // { text: '初年度登録', value: 'shonendoToroku', class: '' },
        // { text: '車両メーカー', value: 'sharyoMakerNm', class: '' },
        // { text: '車種', value: 'shashu', class: '' },
        // { text: 'バックアイ形式', value: 'backeyeKeishikiNm', class: '' },
        // { text: 'ETC管理番号', value: 'etcKanriNo', class: '' },
        // { text: 'ETC形式', value: 'etcKeishikiNm', class: '' },
        // { text: '新シリアル番号', value: 'newSerialNo', class: '' },
        // { text: '旧シリアル番号', value: 'oldSerialNo', class: '' },
        // { text: '冷凍機メーカー', value: 'refrigeratorMakerNm', class: '' },
        // { text: 'ドア番', value: 'doorNo', class: '' },
        // { text: '商品', value: 'shohinNm' },
        { text: '請求作業金額', value: 'seikyuSagyoKingakuKeiDisp', align: 'end', class: '' },
        { text: '請求部材金額', value: 'seikyuBuzaiKingakuKeiDisp', align: 'end', class: '' },
        { text: '支払金額', value: 'shiharaiSagyoKingakuKeiDisp', align: 'end', class: '' },
        { text: '領収書', value: 'receiptFlg', align: 'center', class: '', sortable: false },
        { text: '領収書金額税抜/(税込)', value: 'sagyoKeihiKingaku1Disp', align: 'end', class: '' }
      ]
    },
    filteredBuzaiHassoHeaders () {
      return [
        { text: '操作', value: 'actions', class: 'px-0', align: 'center', sortable: false },
        { text: '伝票番号', value: 'sagyoMeisaiNo' },
        { text: '入出庫日', value: 'sagyoYmdDisp', align: 'center' },
        { text: '納品日', value: 'sagyoYoteiYmdDisp', align: 'center' },
        { text: '案件名', value: 'denpyoBiko4' },
        { text: '操作操作担当者', value: 'nohinTantoshaNm' },
        { text: '納品先', value: 'denpyoBiko5' },
        { text: '納品先担当者', value: 'denpyoBiko2' },
        // { text: '納品書備考', value: 'biko' },
        { text: '郵便番号', value: 'nohinbashoYubinNo' },
        { text: '電話番号', value: 'denpyoBiko3' },
        { text: '個数', value: 'denpyoBiko1' },
        { text: '送り先', value: 'nohinbashoJusho1' },
        { text: '品名', value: 'hanyoBiko' },
        { text: '宛先', value: 'atesaki' },
        { text: '発送日', value: 'hatsuchiYmdDisp', align: 'center' },
        { text: '到着日', value: 'chakuchiYmdDisp', align: 'center' },
        { text: '時間指定', value: 'jikanSbtNm' },
        { text: '伝票種類', value: 'denpyoSbtNm' },
        { text: '送り状伝票番号', value: 'denpyoBiko6' }
        // { text: '請求金額', value: 'seikyuKingakuKeiDisp', align: 'end' }
      ]
    },
    filteredSagyoIraiHeaders () {
      return [
        { text: '', value: 'jissekiMikakuninFlg', class: 'px-0', align: 'center', sortable: false },
        { text: '操作', value: 'actions', class: 'px-0', align: 'center', sortable: false },
        { text: '依頼ステータス', value: 'iraiStatus' },
        { text: '作業依頼先', value: 'sagyoIraisakiNm' },
        { text: '作業担当者', value: 'sagyoTantoshaNm', class: '' },
        { text: '発注番号', value: 'hacchuNo' },
        { text: '作業依頼日', value: 'hacchuYmdDisp', align: 'center' },
        { text: '作業予定日FROM', value: 'hatsuchiYmdDisp', align: 'center' },
        { text: '作業予定日TO', value: 'chakuchiYmdDisp', align: 'center' },
        { text: '作業開始時間', value: 'denpyoBiko2' },
        { text: '車両指定', value: 'ryokinCalcFlg3Disp', align: 'center' },
        { text: '依頼台数', value: 'iraiDaisuDisp', align: 'end' },
        { text: '電話番号', value: 'denpyoBiko1' },
        { text: '支払ランク', value: 'shiharaiRankSbtNm' },
        { text: '作業場所 郵便番号', value: 'sagyobashoYubinNo' },
        { text: '作業場所 住所1', value: 'sagyobashoJusho1' },
        { text: '作業場所 住所2', value: 'sagyobashoJusho2' },
        { text: '作業場所 住所3', value: 'sagyobashoJusho3' }
        // { text: '支払金額', value: 'shiharaiKingakuKeiDisp', align: 'end' },
        // { text: '作業依頼備考', value: 'biko' }
      ]
    },
    // ----------------------------------------------------------------------------------------------------
    // データバインド
    // ----------------------------------------------------------------------------------------------------
    filteredJishaTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        const jisha = this.torihikisakiList.filter(elem2 => elem2.torihikisakiBunruiKbn1 === '02')
        if (!jisha) {
          return false
        }
        return jisha.some(elem2 => elem2.torihikisakiCd === elem.shanaiBiko3) && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    filteredSignalItems () {
      const x = this.tgMstHinmeiList.filter((elem) => {
        return elem.hinshuSbt === '02' && elem.hacchusakiHinshuKbn === '08'
      }).map((elem) => {
        return elem
      })
      return x
    },
    filteredJenreDropDownList () {
      const target = filter.dateFormatter(new Date())
      var defArray = [{ value: null, text: '未選択' }]
      const resultArray = this.jenreList.map(elem => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).map(elem => {
        return {
          value: elem.jenreCd,
          text: `${elem.jenreCd}:${elem.jenreNm}`
        }
      })
      return defArray.concat(resultArray)
    },
    filteredJenreList () {
      const target = filter.dateFormatter(new Date())
      return this.jenreList.map(elem => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredJenreKbnList () {
      var defArray = [{ value: null, text: '未選択' }]
      const resultArray = this.filteredJenreList.map(elem => {
        return {
          value: elem.jenreCd,
          text: `${elem.jenreCd}:${elem.jenreNm}`
        }
      })
      return defArray.concat(resultArray)
    },
    filteredJenreDetailList () {
      return this.shubetsuList.filter((elem) => {
        return elem.sbtShuruiCd === 'TGS014' && elem.kaishaCd === '0010'
      })
    },
    filteredJenreDetailKbnList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'TGS014')
    },
    filteredKihonSagyoRows () {
      const hinmoku = this.rec.trJuchuHinmoku
      const x = this.tgMstHinmeiList.filter((elem) => {
        return elem.hinshuSbt === '02' && elem.hacchusakiHinshuKbn === '01' && (elem.hinmeiCd === 'SA00000000' || elem.hinmeiCd === 'SA99999999')
      }).map((elem) => {
        const index = ((hinmoku) && hinmoku !== null) ? hinmoku.findIndex((hinmoku) => hinmoku.mstHinmeiId === elem.id) : -1
        const result = {
          id: index !== -1 ? hinmoku[index].id : 0,
          mstHinmeiId: elem.id,
          hinshuSbt: elem.hacchusakiHinshuKbn,
          hinmeiCd: elem.hinmeiCd,
          hinmeiNm: elem.hinmeiNm
        }
        return result
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hinmeiCd > elem2.hinmeiCd) { return 1 }
        if (elem1.hinmeiCd === elem2.hinmeiCd) { return 0 }
        return -1
      })
      return x
    },
    filteredOptionSagyoRows () {
      console.log('filteredOptionSagyoRows', this.rec.trJuchuHinmoku)
      const x = this.rec.trJuchuHinmoku.filter((elem) => {
        return elem.hinmokuSbt === '02'
      }).map((elem) => {
        const m = this.tgMstHinmeiList.find((item) => item.mstHinmeiId === elem.mstHinmeiId)
        return {
          ...elem,
          shohinTanka: elem.kihonUnchin > 0 && elem.juchuSuryo > 0 ? elem.kihonUnchin / elem.juchuSuryo : null,
          shohinTankaDisp: elem.kihonUnchin > 0 && elem.juchuSuryo > 0 ? filter.numericFormatter(elem.kihonUnchin / elem.juchuSuryo) : null,
          seikyuKingaku: elem.kihonUnchin,
          shiharaiKingaku: elem.userKingakuKazei1,
          seikyuKingakuDisp: filter.numericFormatter((elem.kihonUnchin) ? elem.kihonUnchin : 0),
          shiharaiKingakuDisp: filter.numericFormatter((elem.userKingakuKazei1) ? elem.userKingakuKazei1 : 0),
          sagyoHyojiOrder: m.sagyoHyojiOrder ? m.sagyoHyojiOrder : 9999,
          hyojiOrder: m.hyojiOrder,
          // 表示用
          hinmeiNm: (m !== undefined) ? m.hinmeiNm : '',
          hinban: (m !== undefined) ? m.hinban : ''
        }
      }).sort((elem1, elem2) => {
        if (elem1.sagyoHyojiOrder - elem2.sagyoHyojiOrder !== 0) { return elem1.sagyoHyojiOrder - elem2.sagyoHyojiOrder }
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hinban > elem2.hinban) { return 1 }
        if (elem1.hinban === elem2.hinban) { return 0 }
        return -1
      })
      return x
    },
    filteredSharyoRows () {
      console.log('filter', this.rows.sharyoRows)
      // 画面バインド用定義値の初期化
      this.seikyuSagyoKingakuKei = 0
      this.seikyuBuzaiKingakuKei = 0
      this.seikyuChoseiKomiKingakuKei = 0
      this.shiharaiKingakuKei = 0

      const self = this
      return this.rows.sharyoRows.filter((elem) => {
        if ((self.filterSharyoSagyoMikanryoFlg && elem.sagyoKanryoFlg) || (self.filterSharyoUriageMikakuteiFlg && elem.uriageKakuteiFlg) || (self.filterSharyoCancelFlg && elem.sagyoCancelFlg === false)) return false
        elem.delFlg = (elem.delFlg) ? elem.delFlg : false
        return true
      }).sort((a, b) => {
        return a.keyNo - b.keyNo
      }).map((elem, index) => {
        // 明細合計金額算出（DBだとInner Viewが重くなりそうなのでCLで実施）
        let tmpSeikyuSagyoKingaku = 0
        let tmpSeikyuBuzaiKingaku = 0
        let tmpShiharaiSagyoKingaku = 0
        if (!elem.delFlg) {
          // 請求作業金額
          self.rows.sharyoKihonRows.filter(item => {
            return item.keyNo === elem.keyNo && window.isFinite(item.seikyuKingaku) && item.seikyuKingaku !== null
          }).map(item => {
            return parseInt(item.seikyuKingaku, 10)
          }).forEach(val => {
            tmpSeikyuSagyoKingaku += val
          })
          self.rows.sharyoOptionRows.filter(item => {
            return item.keyNo === elem.keyNo && window.isFinite(item.seikyuKingaku) && item.seikyuKingaku !== null
          }).map(item => {
            return parseInt(item.seikyuKingaku, 10)
          }).forEach(val => {
            tmpSeikyuSagyoKingaku += val
          })

          // 請求部材金額
          self.rows.sharyoBuzaiRows.filter(item => {
            return item.keyNo === elem.keyNo && window.isFinite(item.seikyuKingaku) && item.seikyuKingaku !== null
          }).map(item => {
            return parseInt(item.seikyuKingaku, 10)
          }).forEach(val => {
            tmpSeikyuBuzaiKingaku += val
          })

          // 支払金額
          self.rows.sharyoKihonRows.filter(item => {
            return item.keyNo === elem.keyNo && window.isFinite(item.shiharaiKingaku) && item.shiharaiKingaku !== null
          }).map(item => {
            return parseInt(item.shiharaiKingaku, 10)
          }).forEach(val => {
            tmpShiharaiSagyoKingaku += val
          })
          self.rows.sharyoOptionRows.filter(item => {
            return item.keyNo === elem.keyNo && window.isFinite(item.shiharaiKingaku) && item.shiharaiKingaku !== null
          }).map(item => {
            return parseInt(item.shiharaiKingaku, 10)
          }).forEach(val => {
            tmpShiharaiSagyoKingaku += val
          })
        }

        elem.seikyuSagyoKingakuKei = tmpSeikyuSagyoKingaku
        elem.seikyuBuzaiKingakuKei = tmpSeikyuBuzaiKingaku
        elem.seikyuKingakukei = elem.seikyuSagyoKingakuKei + elem.seikyuBuzaiKingakuKei
        elem.shiharaiSagyoKingakuKei = tmpShiharaiSagyoKingaku

        // 画面バインド用定義値の更新
        self.seikyuSagyoKingakuKei += tmpSeikyuSagyoKingaku
        self.seikyuBuzaiKingakuKei += tmpSeikyuBuzaiKingaku
        self.seikyuChoseiKomiKingakuKei += (tmpSeikyuSagyoKingaku + tmpSeikyuBuzaiKingaku)
        self.shiharaiKingakuKei += tmpShiharaiSagyoKingaku

        elem.jissekiMikakuninFlg = elem.trSagyoJissekiId && !elem.sagyoKanryoFlg

        // 作業予定日編集
        if (![undefined, null, ''].includes(elem.sagyoYoteiYmdFrom)) {
          elem.sagyoYoteiYmd = filter.dateFormatter(elem.sagyoYoteiYmdFrom)
        }
        if (![undefined, null, ''].includes(elem.sagyoYoteiYmdTo)) {
          elem.sagyoYoteiYmd = elem.sagyoYoteiYmd + '～' + filter.dateFormatter(elem.sagyoYoteiYmdTo)
        }
        elem.jissekiSagyoYmd = elem.jissekiSagyoYmd ? filter.dateFormatter(elem.jissekiSagyoYmd) : ''
        elem.sagyoCancelYmd = elem.sagyoCancelYmd ? filter.dateFormatter(elem.sagyoCancelYmd) : ''
        elem.jissekiSagyoYmdDisp = !elem.sagyoCancelFlg ? elem.jissekiSagyoYmd : [undefined, null, ''].includes(elem.jissekiSagyoYmd) ? elem.sagyoCancelYmd : elem.jissekiSagyoYmd

        const includeTax = [undefined, null, ''].includes(elem.sagyoKeihiKingaku1) ? 0 : elem.sagyoKeihiKingaku1
        const excludeTax = [undefined, null, ''].includes(elem.sagyoKeihiKingaku1) ? 0 : tax.calcWithoutTaxDirect(elem.sagyoKeihiKingaku1, '03', date.getCurrentDate())

        return {
          ...elem,
          index: index + 1,
          sagyoYoteiYmdDisp: elem.sagyoYoteiYmd,
          // seikyuSagyoKingakuKeiDisp: elem.seikyuSagyoKingakuKei === null || elem.seikyuSagyoKingakuKei === undefined ? '' : filter.numericFormatter(elem.seikyuSagyoKingakuKei),
          seikyuSagyoKingakuKeiDisp: filter.numericFormatter(tmpSeikyuSagyoKingaku),
          seikyuBuzaiKingakuKeiDisp: filter.numericFormatter(tmpSeikyuBuzaiKingaku),
          shiharaiSagyoKingakuKeiDisp: filter.numericFormatter(tmpShiharaiSagyoKingaku),
          sagyoKeihiKingaku1Disp: includeTax === 0 ? null : filter.numericFormatter(excludeTax) + ' / (' + filter.numericFormatter(includeTax) + ')'
        }
      })
    },
    filteredBuzaiRows () {
      console.log('filteredBuzaiRows', this.rows.sagyoBuzaiRows)
      const self = this
      const x = this.rec.trJuchuHinmoku.filter((elem) => {
        // elem.delFlg = (elem.delFlg) ? elem.delFlg : false
        return (elem.hinmokuSbt === '04' || elem.hinmokuSbt === '05' || elem.hinmokuSbt === '06')
      }).map((elem) => {
        const m = self.tgMstHinmeiList.find((item) => item.mstHinmeiId === elem.mstHinmeiId)
        const d = indexeddb.getShubetsu('0010', self.shubetsuList, 'TGS012', elem.hinmokuSbt)
        return {
          ...elem,
          // 以下TgPopupBuzaiと同じ定義
          shohinTanka: elem.kihonUnchin > 0 && elem.juchuSuryo > 0 ? elem.kihonUnchin / elem.juchuSuryo : 0,
          shohinTankaDisp: elem.kihonUnchin > 0 && elem.juchuSuryo > 0 ? filter.numericFormatter(elem.kihonUnchin / elem.juchuSuryo) : 0,
          seikyuKingaku: elem.kihonUnchin,
          hinshuSbt: elem.hinmokuSbt,
          hinmeiNm: (m !== undefined) ? m.hinmeiNm : '',
          buzaiIcon: d.komoku1,
          buzaiDescription: d.sbtNm,
          color: d.komoku2
        }
      })
      return x
    },
    filteredBuzaiHassoRows () {
      console.log('filter', this.rows.hassoDenpyoRows)
      const x = this.rows.hassoDenpyoRows.map((elem, index) => {
        return {
          ...elem,
          index: index + 1,
          sagyoYmdDisp: elem.sagyoYmd === undefined || elem.sagyoYmd === null || elem.sagyoYmd === '' ? '' : filter.dateFormatter(elem.sagyoYmd),
          sagyoYoteiYmdDisp: elem.sagyoYoteiYmd === undefined || elem.sagyoYoteiYmd === null || elem.sagyoYoteiYmd === '' ? '' : filter.dateFormatter(elem.sagyoYoteiYmd),
          hatsuchiYmdDisp: elem.hatsuchiYmd === undefined || elem.hatsuchiYmd === null || elem.hatsuchiYmd === '' ? '' : filter.dateFormatter(elem.hatsuchiYmd),
          chakuchiYmdDisp: elem.chakuchiYmd === undefined || elem.chakuchiYmd === null || elem.chakuchiYmd === '' ? '' : filter.dateFormatter(elem.chakuchiYmd),
          seikyuKingakuKeiDisp: elem.seikyuKingakuKei === null || elem.seikyuKingakuKei === undefined ? '' : filter.numericFormatter(elem.seikyuKingakuKei),
          delFlg: (elem.delFlg) ? elem.delFlg : false
        }
      }).sort((a, b) => {
        return a.sagyoMeisaiNo < b.sagyoMeisaiNo ? -1 : 1
      })
      return x
    },
    filteredSagyoIraiRows () {
      console.log('filter', this.rows.sagyoIraiRows)
      const x = this.rows.sagyoIraiRows.map((elem, index) => {
        const elem2 = { ...elem }
        elem2.hacchuYmdDisp = elem.hacchuYmd ? filter.dateFormatter(elem.hacchuYmd) : ''
        elem2.hatsuchiYmdDisp = elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem2.chakuchiYmdDisp = elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem2.iraiDaisuDisp = elem.iraiDaisu === null || elem.iraiDaisu === undefined ? '' : filter.numericFormatter(elem.iraiDaisu)
        elem2.shiharaiKingakuKei = elem.unchinKakuteiFlg ? elem.kakuteiShiharaiKingakuKei : elem.mikakuteiShiharaiKingakuKei
        elem2.shiharaiChoseiKingakuDisp = elem.shiharaiChoseiKingaku === null || elem.shiharaiChoseiKingaku === undefined ? '' : filter.numericFormatter(elem.shiharaiChoseiKingaku)
        elem2.iraiStatus = elem.unchinKakuteiFlg ? '支払確定済み' : elem.ryokinCalcFlg5 ? '作業依頼メール送信失敗' : elem.mailSndrcvYmd ? '作業依頼メール送信済み' : elem.ryokinCalcFlg6 ? '別メールで依頼済み' : elem.draftFlg ? '作業依頼メール仮保存済み' : '作成中'

        elem2.ryokinCalcFlg3Disp = elem.ryokinCalcFlg3 ? 'なし' : 'あり'

        elem2.jissekiMikakuninFlg = elem.mikakuninJissekiSharyoFlg || (elem.notRelationJissekiFlg && (elem.mikakuninSharyoFlg || elem.notIraiRelationMikakuninSharyoFlg))

        elem2.shiharaiChoseiKomiKingakuKei = (elem2.shiharaiKingakuKei ?? 0) + (elem2.shiharaiChoseiKingaku ?? 0)
        elem2.shiharaiKingakuKeiDisp = elem2.shiharaiKingakuKei === null || elem2.shiharaiKingakuKei === undefined ? '' : filter.numericFormatter(elem2.shiharaiKingakuKei)
        elem2.shiharaiChoseiKomiKingakuKeiDisp = elem2.shiharaiChoseiKomiKingakuKei === null || elem2.shiharaiChoseiKomiKingakuKei === undefined ? '' : filter.numericFormatter(elem2.shiharaiChoseiKomiKingakuKei)
        return {
          ...elem2,
          index: index + 1
        }
      }).sort((a, b) => {
        return a.hacchuNo < b.hacchuNo ? -1 : 1
      })
      return x
    },
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredShohinList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.hinshuSbt === '01' && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hinmeiCd > elem2.hinmeiCd) { return 1 }
        if (elem1.hinmeiCd === elem2.hinmeiCd) { return 0 }
        return -1
      })
    },
    filteredSagyoKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'TGK001')
    },
    //
    chumonStatus () {
      if (this.cloneSeikyuKakuteiFlg) return '請求確定'
      if (this.filteredSagyoIraiRows.length === 0 || this.filteredSagyoIraiRows.some((elem) => !elem.ryokinCalcFlg6 && !elem.mailSndrcvYmd)) return '作業準備中'
      if (this.filteredSharyoRows.length === 0 || this.filteredSharyoRows.some((elem) => !elem.sagyoKanryoFlg)) return '作業完了待ち'
      return '作業完了'
    },
    availableSharyoCount () {
      const x = this.rows.sharyoRows.filter((elem) => {
        return elem.delFlg === false && (elem.sagyoCancelFlg === false || (elem.sagyoKanryoFlg === true && elem.sagyoCancelFlg === true))
      })
      //  && (elem.sagyoCancelFlg === false || (elem.sagyoKanryoFlg === true && elem.sagyoCancelFlg === true))

      return x.length
    },

    // ----------------------------------------------------------------------------------------------------
    // 画面制御
    // ----------------------------------------------------------------------------------------------------
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isUpdate () {
      return this.id !== 0
    },
    isExistSharyo () {
      return this.rows.sharyoRows.length > 0
    },
    isDisableSagyoSharyoList () {
      return this.sharyoDaisu <= 0
    },
    isDisabledHassoDenpyo () {
      const x = this.rows.sagyoBuzaiRows.filter((elem) => {
        return (elem.hinshuSbt === '04')
      })
      return x.length <= 0
    },
    isDisabledSagyoIrai () {
      const x = this.rows.sharyoRows.filter((elem) => {
        return (elem.delFlg === false)
      })
      return x.length <= 0
    },
    isShowCancelButton () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isShowDeleteButton () {
      return this.modeKengen === 2 && this.modeOfEdit === 2
    },
    isShowCopyButton () {
      return this.modeKengen === 2 && this.modeOfEdit === 2
    },
    isShowSaveButton () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isKaishaCodeAlret () {
      return ![undefined, null, ''].includes(this.rec.trJuchuMeisai.toritsukesaki) && this.rec.trJuchuMeisai.toritsukesaki.indexOf(SP_TORITSUKESAKI_1) >= 0
    },
    // 件数表示用
    displaySagyoKanryoInfo () {
      const kanryoCount = this.rows.sharyoRows.filter((elem) => elem.delFlg === false && elem.sagyoKanryoFlg).length
      const sharyoCount = this.rows.sharyoRows.filter((elem) => elem.delFlg === false && (elem.sagyoCancelFlg === false || (elem.sagyoCancelFlg && elem.sagyoKanryoFlg))).length
      return '作業完了 (' + kanryoCount + '/' + sharyoCount + ')'
    },
    displayUriageKakuteiInfo () {
      const kanryoCount = this.rows.sharyoRows.filter((elem) => elem.delFlg === false && elem.uriageKakuteiFlg).length
      const sharyoCount = this.rows.sharyoRows.filter((elem) => elem.delFlg === false && (elem.sagyoCancelFlg === false || (elem.sagyoCancelFlg && elem.sagyoKanryoFlg))).length
      return '売上確定 (' + kanryoCount + '/' + sharyoCount + ')'
    },
    displayYayoiRenkeiNotInfo () {
      const yayoiNotCount = this.rows.sharyoRows.filter((elem) => elem.delFlg === false && elem.notYayoiRenkeiFlg).length
      const sharyoCount = this.rows.sharyoRows.filter((elem) => elem.delFlg === false && (elem.sagyoCancelFlg === false || (elem.sagyoCancelFlg && elem.sagyoKanryoFlg))).length
      this.notYayoiRenkeiFlg = yayoiNotCount === sharyoCount
      return '弥生連携不要 (' + yayoiNotCount + '/' + sharyoCount + ')'
    },
    displayMatomeSeikyuInfo () {
      const matomeSeikyuCount = this.rows.sharyoRows.filter((elem) => elem.delFlg === false && elem.matomeSeikyuFlg).length
      const sharyoCount = this.rows.sharyoRows.filter((elem) => elem.delFlg === false && (elem.sagyoCancelFlg === false || (elem.sagyoCancelFlg && elem.sagyoKanryoFlg))).length
      this.matomeSeikyuFlg = matomeSeikyuCount === sharyoCount
      return '社長請求 (' + matomeSeikyuCount + '/' + sharyoCount + ')'
    }
  },
  created () {
    this.id = this.$route.params.id
    // 戻る制御用パラメータ取得（※未存在時は”案件一覧”宛てとする）
    if (this.$route.params.backactionno && this.$route.params.backactionno !== null && isFinite(this.$route.params.backactionno)) {
      this.backActionNo = this.$route.params.backactionno
    } else {
      this.backActionNo = 0
    }
  },
  mounted () {
    console.log('HelpUseFlg', this.helpUseFlg)
    // 呼び出しキー読み替え
    this.id = this.$route.params.id

    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      console.log('getCloneTargetMethod')
      return {
        rec: this.rec,
        rows: this.rows,
        mitsumoriIraiDaisu: this.mitsumoriIraiDaisu,
        kihonSagyoSeikyuKingaku: this.kihonSagyoSeikyuKingaku,
        kihonSagyoShiharaiKingaku: this.kihonSagyoShiharaiKingaku,
        sharyoDaisu: this.sharyoDaisu
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const self = this
      const opt = {
        nextCallback: next,
        savePromise: function () {
          return new Promise((resolve) => {
            self.registerPromise().then(data => {
              if (data.isValid) {
                resolve()
              } else {
                resolve('error')
              }
            })
          })
        }
      }
      this.preventTransitionSave(opt)
    },
    setCloneData: function (e) {
      this.cloneData = dolly.clone(this.getCloneTargetMethod())
    },

    // ----------------------------------------------------------------------------------------------------
    // メイン
    // ----------------------------------------------------------------------------------------------------
    initialize () {
      console.log('★★★initialize★★★')

      // 呼び出しキー読み替え
      this.id = this.$route.params.id

      // 文字列の場合数値変換
      if (isFinite(this.id)) {
        if (typeof this.id !== 'number') {
          this.id = parseFloat(this.id)
        }
      } else {
        this.id = 0
      }

      const self = this
      const option = {
        loadMasters: ['msystax', 'msttorihikisaki', 'mstjinin', 'msthinmei', 'mstaddress', 'mstshubetsu', 'msyskubun', 'vwcmsthinmeiexttg', 'msysmessage', 'mstmailtemplate', 'tgmstjinin', 'msttgjenre'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            if (!self.isSaving) {
              self.clear()
              self.getCloneTargetMethod()
            }
            self.isSaving = false
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('★★★savedInputRestorePromise★★★')
            // ユーザ保存項目の復元
            resolve()
          })
        },
        existsIdMethod: () => {
          console.log('★★★existsIdMethod★★★', self.id)
          return self.id !== 0
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('★★★settingButtonStatePromise★★★')
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (self.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingItemMethod', kengen)
            resolve()
          })
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    fetchData: function () {
      const self = this
      return new Promise((resolve, reject) => {
        self.HttpClient
          .get(`/api/v1/Tgrcod0021/FindByJuchuMeisaiId2?id=${self.id}`)
          .then((data) => {
            console.log('fetchData', data)
            if (data.payload) {
              this.assignData(data.payload)
            }
            resolve()
          })
          .catch((e) => {
            console.log('error', e)
            this.Effects.loadComplete()
            modals.showError(e.message)
            reject(e)
          })
      })
    },
    // FindWithChildrenで取得した値を割り当てる（fetchData, registerRequestPromise）
    assignData: function (data) {
      this.isLoading = true
      this.rec = {
        ...data.item1,
        trJuchuKihon: {
          ...data.item1.trJuchuKihon,
          juchuYmd: data.item1.trJuchuKihon.juchuYmd ? filter.dateFormatter(data.item1.trJuchuKihon.juchuYmd) : ''
        },
        trJuchuMeisai: {
          ...data.item1.trJuchuMeisai,
          hatsuchiYmd: data.item1.trJuchuMeisai.hatsuchiYmd ? filter.dateFormatter(data.item1.trJuchuMeisai.hatsuchiYmd) : '',
          chakuchiYmd: data.item1.trJuchuMeisai.chakuchiYmd ? filter.dateFormatter(data.item1.trJuchuMeisai.chakuchiYmd) : '',
          unchinCheckYmd: data.item1.trJuchuMeisai.unchinCheckYmd ? filter.dateFormatter(data.item1.trJuchuMeisai.unchinCheckYmd) : '',
          sagyoNaiyoKakuteiYmd: data.item1.trJuchuMeisai.sagyoNaiyoKakuteiYmd ? filter.dateFormatter(data.item1.trJuchuMeisai.sagyoNaiyoKakuteiYmd) : ''
        }
      }

      this.juchuKihonId = this.rec.trJuchuKihon.id
      this.cloneSagyoNaiyoKakuteiFlg = this.rec.trJuchuMeisai.sagyoNaiyoKakuteiFlg
      this.cloneSeikyuKakuteiFlg = this.rec.trJuchuMeisai.unchinKakuteiFlg

      this.rows = data.item2

      // オプション作業編集
      this.rows.sharyoOptionRows.map((elem) => {
        elem.shohinTanka = ![null, 0, ''].includes(elem.juchuSuryo) && ![null, 0, ''].includes(elem.seikyuKingaku) ? formatter.removeComma(elem.seikyuKingaku) / elem.juchuSuryo : 0
        return elem
      })

      // 部材情報編集
      this.rows.sharyoBuzaiRows.map((elem) => {
        const d = indexeddb.getShubetsu('0010', this.shubetsuList, 'TGS012', elem.hacchusakiHinshuKbn)
        elem.buzaiIcon = d.komoku1
        elem.buzaiDescription = d.sbtNm
        elem.color = d.komoku2
        elem.shohinTanka = ![null, 0, ''].includes(elem.juchuSuryo) && ![null, 0, ''].includes(elem.seikyuKingaku) ? formatter.removeComma(elem.seikyuKingaku) / elem.juchuSuryo : 0
        return elem
      })

      // 見積依頼台数セット
      this.mitsumoriIraiDaisu = this.availableSharyoCount
      if (this.mitsumoriIraiDaisu > 0) {
        this.sharyoDaisu = this.mitsumoriIraiDaisu
      }
      // 基本作業請求金額（※先頭を取得）
      const kihonSagyoIndex = this.rows.sharyoKihonRows.findIndex((elem) => elem.mstHinmeiId === 19999)
      this.kihonSagyoSeikyuKingaku = 0
      this.kihonSagyoShiharaiKingaku = 0
      if (kihonSagyoIndex >= 0) {
        this.kihonSagyoSeikyuKingaku = this.rows.sharyoKihonRows[kihonSagyoIndex].seikyuKingaku ? filter.numericFormatter(this.rows.sharyoKihonRows[kihonSagyoIndex].seikyuKingaku) : 0
        this.kihonSagyoShiharaiKingaku = this.rows.sharyoKihonRows[kihonSagyoIndex].shiharaiKingaku ? filter.numericFormatter(this.rows.sharyoKihonRows[kihonSagyoIndex].shiharaiKingaku) : 0
      }

      // 信号設定
      this.rows.signalItems = this.filteredSignalItems
      this.rows.signalItems.map((elem) => {
        const t = (this.rec.trJuchuHinmoku || this.rec.trJuchuHinmoku.length > 0) ? this.rec.trJuchuHinmoku.find((item) => item.mstHinmeiId === elem.mstHinmeiId) : undefined
        // 未登録時のみ01:常時,02:ACCを初期セット
        elem.value = t !== undefined
      })
      this.rows.kihonSagyoRows = this.filteredKihonSagyoRows
      // オプション作業
      this.rows.optionSagyoRows = this.filteredOptionSagyoRows
      // 部材
      this.rows.sagyoBuzaiRows = this.filteredBuzaiRows

      this.$nextTick(() => {
        this.isLoading = false
        this.setCloneData()
      })
      this.isLoading = false
    },
    clear: function () {
      this.rec = {
        // 受付情報 受注基本
        trJuchuKihon: {
          juchuYmd: date.getCurrentDate(),
          chumonNo: null,
          unchinKakuteiFlg: false,
          // tokuisakiId: null,
          tokuisakiId: 10001,
          cancelFlg: false,
          cancelText: null
        },
        // 受付情報 受注明細-拡張連結
        trJuchuMeisai: {
          jishaDenpyoNo: null,
          oyaDenpyoNo: null,
          denpyoHanyoSbt3: '01', // 請求ランク（01固定）
          unchinKakuteiFlg: false,
          unchinCheckTantoshaId: null,
          unchinCheckYmd: '',
          hatsuchiYmd: '',
          chakuchiYmd: '',
          denpyoHanyoSbt4: null,
          denpyoHanyoSbt6: null,
          ninushiId: null,
          denpyoBiko1: null,
          denpyoBiko2: null,
          denpyoBiko3: null,
          denpyoHanyoSbt2: null,
          tantoshaId: this.loginUserId,
          sagyoNaiyoKakuteiFlg: false,
          sagyoNaiyoKakuteiTantoshaId: null,
          sagyoNaiyoKakuteiYmd: null,
          toritsukesakiYubinNo: null,
          toritsukesakiJusho1: null,
          toritsukesakiJusho2: null,
          toritsukesakiJusho3: null,
          sagyobashoYubinNo: null,
          sagyobashoJusho1: null,
          sagyobashoJusho2: null,
          sagyobashoJusho3: null,
          shohinId: null,
          biko: null,
          userKingakuKazei1: null,
          seikyuZumiFlg: false,
          seikyuTomeFlg: false,
          seikyuBiko: null,
          denpyoBiko4: null,
          denpyoHanyoSbt5: null,
          denpyoBiko5: null,
          denpyoBiko6: null,
          denpyoBiko7: null,
          denpyoBiko8: null,
          toritsukesaki: null,
          hanyoBiko: null
        },
        trJuchuHinmoku: [],
        // 見積情報 作業明細-拡張連結
        trSagyoMeisai: {
          iraiDaisu: null,
          biko: null,
          kihonUnchin: null,
          userKingakuKazei1: null,
          userKingakuKazei2: null,
          denpyoHanyoSbt2: null,
          hanyoBiko: null
        },
        // 見積情報 作業品目
        trSagyoHinmoku: [],
        // 車両
        trSagyoSharyoList: [],
        trSagyoSharyoHimokuList: [],
        // チェックリスト
        vwCTgrcod002080: [],
        vwCTgrcod002080Receipt: [],
        vwCTgrcod002081: [],
        sagyoNaiyoKakuteiChangeFlg: false,
        seikyuKakuteiChangeFlg: false
      }
      const defaultOptionList = this.tgMstHinmeiList.filter((elem) => {
        return elem.hinshuSbt === '02' && elem.hacchusakiHinshuKbn === '02' && elem.sagyoHyojiOrder > 0
      }).map((elem) => {
        const result = {
          id: -1,
          mstHinmeiId: elem.id,
          juchuSuryo: null,
          shohinTanka: null,
          shohinTankaDisp: null,
          seikyuKingaku: null,
          shiharaiKingaku: null,
          hinshuSbt: elem.hacchusakiHinshuKbn,
          hinmeiCd: elem.hinmeiCd,
          hinmeiNm: elem.hinmeiNm,
          hinban: elem.hinban,
          katashiki: elem.katashiki,
          hyojiOrder: elem.hyojiOrder ? elem.hyojiOrder : 9999,
          sagyoHyojiOrder: elem.sagyoHyojiOrder ? elem.sagyoHyojiOrder : 9999
        }
        return result
      }).sort((elem1, elem2) => {
        if (elem1.sagyoHyojiOrder - elem2.sagyoHyojiOrder !== 0) { return elem1.sagyoHyojiOrder - elem2.sagyoHyojiOrder }
      })
      this.rows = {
        signalItems: this.filteredSignalItems,
        kihonSagyoRows: this.filteredKihonSagyoRows,
        optionSagyoRows: Object.assign([], defaultOptionList),
        sagyoBuzaiRows: [],
        sharyoRows: [],
        sharyoKihonRows: [],
        sharyoOptionRows: [],
        sharyoBuzaiRows: [],
        hassoDenpyoRows: [],
        sagyoIraiRows: []
      }
      // 信号初期値設定
      this.rows.signalItems.map((elem) => {
        elem.value = false
      })

      this.filterSharyoSagyoMikanryoFlg = false
      this.filterSharyoUriageMikakuteiFlg = false
      this.cloneSagyoNaiyoKakuteiFlg = false
      this.cloneSeikyuKakuteiFlg = false
      this.seikyuRankChangeFlg = false
      this.juchuKihonId = 0
      this.hassoDenpyoId = 0
      this.sharyoId = 0
      this.sagyoIraiId = 0
      this.mitsumoriIraiDaisu = 0
      this.kihonSagyoSeikyuKingaku = 0
      this.kihonSagyoShiharaiKingaku = 0
      this.sharyoDaisu = 0
    },

    // ----------------------------------------------------------------------------------------------------
    // 取引先チェック
    // ----------------------------------------------------------------------------------------------------
    checkTorihikisakiStatus: function () {
      this.orderStopFlg = false
      const torihiksakiRec = indexeddb.getRecord(this.torihikisakiList, this.rec.trJuchuKihon.tokuisakiId)
      if (torihiksakiRec) {
        if (![undefined, null, false].includes(torihiksakiRec.orderStopFlg)) {
          this.orderStopFlg = torihiksakiRec.orderStopFlg
        }
      }
    },

    // ----------------------------------------------------------------------------------------------------
    // 編集系入力制御
    // ----------------------------------------------------------------------------------------------------
    onAllSagyoKanryoFlgChange: function () {
      if (this.isLoading === false) {
        if (!this.statusChangeDialogFlg) {
          // ダイアログ無し
          if (this.rec.trJuchuMeisai.sagyoNaiyoKakuteiFlg) {
            this.rec.trJuchuMeisai.sagyoNaiyoKakuteiTantoshaId = this.loginUserId
            this.rec.trJuchuMeisai.sagyoNaiyoKakuteiYmd = filter.dateFormatter(new Date())
            if (this.rows.sharyoRows) {
              this.rows.sharyoRows.filter((elem) => {
                return elem.sagyoCancelFlg === false
              }).forEach((item) => {
                if (!item.sagyoKanryoFlg) {
                  item.sagyoKanryoFlg = true
                  item.unchinCheckYmd = filter.dateFormatter(new Date())
                  item.unchinCheckTantoshaId = this.loginUserId
                  item.editFlg = true
                }
              })
            }
          } else {
            this.rec.trJuchuMeisai.sagyoNaiyoKakuteiTantoshaId = null
            this.rec.trJuchuMeisai.sagyoNaiyoKakuteiYmd = null
            if (this.rows.sharyoRows) {
              this.rows.sharyoRows.filter((elem) => {
                return elem.sagyoCancelFlg === false
              }).forEach((item) => {
                item.sagyoKanryoFlg = false
                item.unchinCheckYmd = null
                item.unchinCheckTantoshaId = null
                item.editFlg = true
              })
            }
          }
        } else {
          // ダイアログ有り
          if (this.rec.trJuchuMeisai.sagyoNaiyoKakuteiFlg) {
            modals.showConfirmYesNo('TGRCOQ10').then((ok) => {
              if (ok !== false && ok !== undefined) {
                this.rec.trJuchuMeisai.sagyoNaiyoKakuteiTantoshaId = this.loginUserId
                this.rec.trJuchuMeisai.sagyoNaiyoKakuteiYmd = filter.dateFormatter(new Date())
                if (this.rows.sharyoRows) {
                  this.rows.sharyoRows.filter((elem) => {
                    return elem.sagyoCancelFlg === false
                  }).forEach((item) => {
                    if (!item.sagyoKanryoFlg) {
                      item.sagyoKanryoFlg = true
                      item.unchinCheckYmd = filter.dateFormatter(new Date())
                      item.unchinCheckTantoshaId = this.loginUserId
                      item.editFlg = true
                    }
                  })
                }
              } else {
                // NOなので元値に戻す
                this.rec.trJuchuMeisai.sagyoNaiyoKakuteiFlg = false
              }
            })
          } else {
            modals.showConfirmYesNo('TGRCOQ11').then((ok) => {
              if (ok !== false && ok !== undefined) {
                this.rec.trJuchuMeisai.sagyoNaiyoKakuteiTantoshaId = null
                this.rec.trJuchuMeisai.sagyoNaiyoKakuteiYmd = null
                if (this.rows.sharyoRows) {
                  this.rows.sharyoRows.filter((elem) => {
                    return elem.sagyoCancelFlg === false
                  }).forEach((item) => {
                    item.sagyoKanryoFlg = false
                    item.unchinCheckYmd = null
                    item.unchinCheckTantoshaId = null
                    item.editFlg = true
                  })
                }
              } else {
                // NOなので元値に戻す
                this.rec.trJuchuMeisai.sagyoNaiyoKakuteiFlg = true
              }
            })
          }
        }
      }
    },
    onAllUriageKakuteiFlgChange: function () {
      if (this.isLoading === false) {
        if (!this.statusChangeDialogFlg) {
          // ダイアログ無し
          if (this.rec.trJuchuMeisai.unchinKakuteiFlg) {
            this.rec.trJuchuMeisai.unchinCheckTantoshaId = this.loginUserId
            this.rec.trJuchuMeisai.unchinCheckYmd = filter.dateFormatter(new Date())
            if (this.rows.sharyoRows) {
              this.rows.sharyoRows.filter((elem) => {
                return elem.sagyoCancelFlg === false
              }).forEach((item) => {
                if (!item.uriageKakuteiFlg) {
                  item.uriageKakuteiFlg = true
                  item.uriageKakuteiYmd = filter.dateFormatter(new Date())
                  item.uriageKakuteiTantoshaId = this.loginUserId
                  item.editFlg = true
                }
              })
            }
          } else {
            this.rec.trJuchuMeisai.unchinCheckTantoshaId = null
            this.rec.trJuchuMeisai.unchinCheckYmd = null
            if (this.rows.sharyoRows) {
              this.rows.sharyoRows.filter((elem) => {
                return elem.sagyoCancelFlg === false
              }).forEach((item) => {
                item.uriageKakuteiFlg = false
                item.uriageKakuteiYmd = null
                item.uriageKakuteiTantoshaId = null
                item.uriageKakuteiTantoshaNm = null
                item.editFlg = true
              })
            }
          }
        } else {
          // ダイアログ有り
          if (this.rec.trJuchuMeisai.unchinKakuteiFlg) {
            modals.showConfirmYesNo('TGRCOQ12').then((ok) => {
              if (ok !== false && ok !== undefined) {
                this.rec.trJuchuMeisai.unchinCheckTantoshaId = this.loginUserId
                this.rec.trJuchuMeisai.unchinCheckYmd = filter.dateFormatter(new Date())
                if (this.rows.sharyoRows) {
                  this.rows.sharyoRows.filter((elem) => {
                    return elem.sagyoCancelFlg === false
                  }).forEach((item) => {
                    if (!item.uriageKakuteiFlg) {
                      item.uriageKakuteiFlg = true
                      item.uriageKakuteiYmd = filter.dateFormatter(new Date())
                      item.uriageKakuteiTantoshaId = this.loginUserId
                      item.editFlg = true
                    }
                  })
                }
              } else {
                // NOなので元値に戻す
                this.rec.trJuchuMeisai.unchinKakuteiFlg = !this.rec.trJuchuMeisai.unchinKakuteiFlg
              }
            })
          } else {
            modals.showConfirmYesNo('TGRCOQ13').then((ok) => {
              if (ok !== false && ok !== undefined) {
                this.rec.trJuchuMeisai.unchinCheckTantoshaId = null
                this.rec.trJuchuMeisai.unchinCheckYmd = null
                if (this.rows.sharyoRows) {
                  this.rows.sharyoRows.filter((elem) => {
                    return elem.sagyoCancelFlg === false
                  }).forEach((item) => {
                    item.uriageKakuteiFlg = false
                    item.uriageKakuteiYmd = null
                    item.uriageKakuteiTantoshaId = null
                    item.uriageKakuteiTantoshaNm = null
                    item.editFlg = true
                  })
                }
              } else {
                // NOなので元値に戻す
                this.rec.trJuchuMeisai.unchinKakuteiFlg = !this.rec.trJuchuMeisai.unchinKakuteiFlg
              }
            })
          }
        }
      }
    },
    onAllYayoiRenkeiFlgChange: function () {
      if (this.isLoading === false) {
        if (!this.statusChangeDialogFlg) {
          // ダイアログ無し
          if (this.notYayoiRenkeiFlg) {
            if (this.rows.sharyoRows) {
              this.rows.sharyoRows.filter((elem) => {
                return elem.sagyoCancelFlg === false
              }).forEach((item) => {
                item.notYayoiRenkeiFlg = true
                item.editFlg = true
              })
            }
          } else {
            if (this.rows.sharyoRows) {
              this.rows.sharyoRows.filter((elem) => {
                return elem.sagyoCancelFlg === false
              }).forEach((item) => {
                item.notYayoiRenkeiFlg = false
                item.editFlg = true
              })
            }
          }
        } else {
          // ダイアログ有
          if (this.notYayoiRenkeiFlg) {
            modals.showConfirmYesNo('TGRCOQ14').then((ok) => {
              if (ok !== false && ok !== undefined) {
                if (this.rows.sharyoRows) {
                  this.rows.sharyoRows.filter((elem) => {
                    return elem.sagyoCancelFlg === false
                  }).forEach((item) => {
                    item.notYayoiRenkeiFlg = true
                    item.editFlg = true
                  })
                }
              } else {
                // NOなので元値に戻す
                this.notYayoiRenkeiFlg = !this.notYayoiRenkeiFlg
              }
            })
          } else {
            modals.showConfirmYesNo('TGRCOQ15').then((ok) => {
              if (ok !== false && ok !== undefined) {
                if (this.rows.sharyoRows) {
                  this.rows.sharyoRows.filter((elem) => {
                    return elem.sagyoCancelFlg === false
                  }).forEach((item) => {
                    item.notYayoiRenkeiFlg = false
                    item.editFlg = true
                  })
                }
              } else {
                // NOなので元値に戻す
                this.notYayoiRenkeiFlg = !this.notYayoiRenkeiFlg
              }
            })
          }
        }
      }
    },
    onAllMatomeSeikyuFlgChange: function () {
      if (this.isLoading === false) {
        if (!this.statusChangeDialogFlg) {
          // ダイアログ無し
          if (this.matomeSeikyuFlg) {
            if (this.rows.sharyoRows) {
              this.rows.sharyoRows.forEach((item) => {
                item.matomeSeikyuFlg = true
                item.editFlg = true
              })
            }
          } else {
            if (this.rows.sharyoRows) {
              this.rows.sharyoRows.forEach((item) => {
                item.matomeSeikyuFlg = false
                item.editFlg = true
              })
            }
          }
        } else {
          // ダイアログ有
          if (this.matomeSeikyuFlg) {
            modals.showConfirmYesNo('TGRCOQ14').then((ok) => {
              if (ok !== false && ok !== undefined) {
                if (this.rows.sharyoRows) {
                  this.rows.sharyoRows.forEach((item) => {
                    item.matomeSeikyuFlg = true
                    item.editFlg = true
                  })
                }
              } else {
                // NOなので元値に戻す
                this.matomeSeikyuFlg = !this.matomeSeikyuFlg
              }
            })
          } else {
            modals.showConfirmYesNo('TGRCOQ15').then((ok) => {
              if (ok !== false && ok !== undefined) {
                if (this.rows.sharyoRows) {
                  this.rows.sharyoRows.forEach((item) => {
                    item.matomeSeikyuFlg = false
                    item.editFlg = true
                  })
                }
              } else {
                // NOなので元値に戻す
                this.matomeSeikyuFlg = !this.matomeSeikyuFlg
              }
            })
          }
        }
        if (this.matomeSeikyuFlg) {
          // 売上確定
          this.rec.trJuchuMeisai.unchinKakuteiFlg = true
          this.onAllUriageKakuteiFlgChange()
          // 弥生連携不要
          this.notYayoiRenkeiFlg = true
          this.onAllYayoiRenkeiFlgChange()
        }
      }
    },
    onToritsukesakiYubinInputFocus: function () {
      this.savedToritsukeYubinNo = this.rec.trJuchuMeisai.toritsukesakiYubinNo
      this.savedToritsukeJusho1 = this.rec.trJuchuMeisai.toritsukesakiJusho1
      this.savedToritsukeJusho2 = this.rec.trJuchuMeisai.toritsukesakiJusho2
      this.savedToritsukeJusho3 = this.rec.trJuchuMeisai.toritsukesakiJusho3
    },
    onToritsukesakiYubinInputBlur: function () {
      if (this.savedToritsukeYubinNo !== this.rec.trJuchuMeisai.toritsukesakiYubinNo) {
        var zipCode = this.rec.trJuchuMeisai.toritsukesakiYubinNo.replaceAll('-', '')
        const self = this
        const x = new YubinBango.Core(zipCode, function (addr) {
          self.rec.trJuchuMeisai = {
            ...self.rec.trJuchuMeisai,
            toritsukesakiJusho1: addr.region + addr.locality + addr.street
          }
          self.copyPostCode()
          self.copyAddress1()
          self.copyAddress2()
        })
        console.log('onToritsukesakiYubinInputBlur', x)
      } else {
        this.copyPostCode()
        this.copyAddress1()
        this.copyAddress2()
      }
    },
    onSagyobashoYubinInputFocus: function () {
      this.savedSagyobashoYubinNo = this.rec.trJuchuMeisai.sagyobashoYubinNo
    },
    onSagyobashoYubinInputBlur: function () {
      if (this.savedSagyobashoYubinNo !== this.rec.trJuchuMeisai.sagyobashoYubinNo) {
        const yubinNo = this.rec.trJuchuMeisai.sagyobashoYubinNo.replaceAll('-', '')
        const self = this
        const x = new YubinBango.Core(yubinNo, function (addr) {
          self.rec.trJuchuMeisai = {
            ...self.rec.trJuchuMeisai,
            sagyobashoJusho1: addr.region + addr.locality + addr.street
          }
        })
        console.log('onSagyobashoYubinInputBlur', x)
      }
      this.savedSagyobashoYubinNo = null
    },
    onToritsukesakiJusho1Focus: function () {
      this.savedToritsukeJusho1 = this.rec.trJuchuMeisai.toritsukesakiJusho1
    },
    onToritsukesakiJusho2Focus: function () {
      this.savedToritsukeJusho2 = this.rec.trJuchuMeisai.toritsukesakiJusho2
    },

    // ----------------------------------------------------------------------
    // 住所情報複写
    // ----------------------------------------------------------------------
    copyPostCode: function () {
      if (this.rec.trJuchuMeisai.toritsukesakiYubinNo && ([undefined, null, ''].includes(this.rec.trJuchuMeisai.sagyobashoYubinNo) || this.savedToritsukeYubinNo === this.rec.trJuchuMeisai.sagyobashoYubinNo)) {
        this.rec.trJuchuMeisai.sagyobashoYubinNo = this.rec.trJuchuMeisai.toritsukesakiYubinNo
        this.savedToritsukeYubinNo = this.rec.trJuchuMeisai.toritsukesakiYubinNo
      }
      return true
    },
    copyAddress1: function () {
      if (this.rec.trJuchuMeisai.toritsukesakiJusho1 && ([undefined, null, ''].includes(this.rec.trJuchuMeisai.sagyobashoJusho1) || this.savedToritsukeJusho1 === this.rec.trJuchuMeisai.sagyobashoJusho1)) {
        this.rec.trJuchuMeisai.sagyobashoJusho1 = this.rec.trJuchuMeisai.toritsukesakiJusho1
        this.savedToritsukeJusho1 = this.rec.trJuchuMeisai.toritsukesakiJusho1
      }
      return true
    },
    copyAddress2: function () {
      if (this.rec.trJuchuMeisai.toritsukesakiJusho2 && ([undefined, null, ''].includes(this.rec.trJuchuMeisai.sagyobashoJusho2) || this.savedToritsukeJusho2 === this.rec.trJuchuMeisai.sagyobashoJusho2)) {
        this.rec.trJuchuMeisai.sagyobashoJusho2 = this.rec.trJuchuMeisai.toritsukesakiJusho2
        this.savedToritsukeJusho2 = this.rec.trJuchuMeisai.toritsukesakiJusho2
      }
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 編集系ボタン制御
    // ----------------------------------------------------------------------------------------------------
    onPastUketsukeSearchButtonClick: function () {
      this.pastUketsukeSearchItem = {
        ...this.pastUketsukeSearchItem,
        tokuisakiId: this.rec.trJuchuKihon.tokuisakiId,
        toritsukesakiNm: this.rec.trJuchuMeisai.toritsukesaki
      }
      this.isShowPastUketsukeSearchDialog = true
    },
    onPastUketsukeSearchDialogClose: function (pastRec) {
      if (pastRec !== null) {
        this.isLoading = true
        // 必要分のみコピーする（オブジェクトコピーはしない）
        this.rec = {
          ...this.rec,
          trJuchuKihon: {
            ...this.rec.trJuchuKihon,
            // 得意先の変更忘れを防ぐために初期化
            tokuisakiId: null,
            cancelFlg: false,
            cancelText: null
          },
          trJuchuMeisai: {
            ...this.rec.trJuchuMeisai,
            denpyoHanyoSbt4: pastRec.trJuchuMeisai.denpyoHanyoSbt4,
            denpyoHanyoSbt6: pastRec.trJuchuMeisai.denpyoHanyoSbt6,
            toritsukesaki: pastRec.trJuchuMeisai.toritsukesaki,
            denpyoBiko1: pastRec.trJuchuMeisai.denpyoBiko1,
            denpyoBiko2: pastRec.trJuchuMeisai.denpyoBiko2,
            denpyoBiko3: pastRec.trJuchuMeisai.denpyoBiko3,
            toritsukesakiYubinNo: pastRec.trJuchuMeisai.toritsukesakiYubinNo,
            toritsukesakiJusho1: pastRec.trJuchuMeisai.toritsukesakiJusho1,
            toritsukesakiJusho2: pastRec.trJuchuMeisai.toritsukesakiJusho2,
            toritsukesakiJusho3: pastRec.trJuchuMeisai.toritsukesakiJusho3,
            hanyoBiko: pastRec.trJuchuMeisai.hanyoBiko,
            sagyobashoYubinNo: pastRec.trJuchuMeisai.sagyobashoYubinNo,
            sagyobashoJusho1: pastRec.trJuchuMeisai.sagyobashoJusho1,
            sagyobashoJusho2: pastRec.trJuchuMeisai.sagyobashoJusho2,
            sagyobashoJusho3: pastRec.trJuchuMeisai.sagyobashoJusho3,
            denpyoBiko6: pastRec.trJuchuMeisai.toritsukesaki.indexOf(SP_TORITSUKESAKI_1) >= 0 ? null : pastRec.trJuchuMeisai.denpyoBiko6,
            denpyoBiko7: pastRec.trJuchuMeisai.denpyoBiko7,
            denpyoBiko8: pastRec.trJuchuMeisai.denpyoBiko8,
            biko: pastRec.trJuchuMeisai.biko,
            //
            denpyoHanyoSbt2: pastRec.trJuchuMeisai.denpyoHanyoSbt2,
            shohinId: pastRec.trJuchuMeisai.shohinId,
            sagyoNaiyoKakuteiFlg: false,
            unchinKakuteiFlg: false,
            seikyuTomeFlg: false,
            seikyuBiko: null
          }
        }

        // 品目は作業がない場合のみ複写
        if (!this.rec.trJuchuHinmoku || this.rec.trJuchuHinmoku.length <= 0) {
          pastRec.trJuchuHinmoku.forEach((item) => {
            const m = this.tgMstHinmeiList.find((m) => m.mstHinmeiId === item.mstHinmeiId)
            // 部材は除外する
            if (!['04', '05', '06'].includes(m.hinshuSbt)) {
              const tmpJuchuHinmoku = {
                id: 0,
                mstHinmeiId: item.mstHinmeiId,
                juchuSuryo: item.juchuSuryo,
                kihonUnchin: item.kihonUnchin,
                UserKingakuKazei1: item.UserKingakuKazei1,
                hinmeiCd: item.hinmeiCd,
                hinmeiNm: item.hinmeiNm,
                hinmeiBiko: item.hinmeiBiko,
                hinban: item.hinban,
                katashiki: item.katashiki,
                hinshuSbt: m.hacchusakiHinshuKbn,
                // オプション作業フィルタ用
                hinmokuSbt: m.hacchusakiHinshuKbn
              }
              this.rec.trJuchuHinmoku.push(tmpJuchuHinmoku)
            }
          })

          // 信号設定
          this.rows.signalItems = this.filteredSignalItems
          this.rows.signalItems.map((elem) => {
            const t = (this.rec.trJuchuHinmoku || this.rec.trJuchuHinmoku.length > 0) ? this.rec.trJuchuHinmoku.find((item) => item.mstHinmeiId === elem.mstHinmeiId) : undefined
            // 未登録時のみ01:常時,02:ACCを初期セット
            elem.value = t !== undefined
          })
          this.rows.kihonSagyoRows = this.filteredKihonSagyoRows
          // オプション作業
          this.rows.optionSagyoRows = this.filteredOptionSagyoRows
        }

        this.$nextTick(() => { this.isLoading = false })
      }
      this.isShowPastUketsukeSearchDialog = false
    },
    onToritsukesakiSearchButtonClick: function () {
      this.isShowToritsukesakiSearchDialog = true
    },
    onToritsukesakiSearchDialogClose: function (e) {
      console.log(e)
      if (e !== null) {
        this.isLoading = true
        this.rec.trJuchuMeisai = {
          ...this.rec.trJuchuMeisai,
          toritsukesaki: e.toritsukesakiNm,
          denpyoBiko1: e.denpyoBiko1,
          denpyoBiko2: e.denpyoBiko2,
          denpyoBiko3: e.denpyoBiko3,
          toritsukesakiYubinNo: e.toritsukesakiYubinNo,
          toritsukesakiJusho1: e.toritsukesakiJusho1,
          toritsukesakiJusho2: e.toritsukesakiJusho2,
          toritsukesakiJusho3: e.toritsukesakiJusho3,
          hanyoBiko: e.toritsukesakiBiko,
          sagyobashoYubinNo: e.sagyobashoYubinNo,
          sagyobashoJusho1: e.sagyobashoJusho1,
          sagyobashoJusho2: e.sagyobashoJusho2,
          sagyobashoJusho3: e.sagyobashoJusho3,
          denpyoBiko6: e.denpyoBiko6,
          denpyoBiko7: e.denpyoBiko7,
          denpyoBiko8: e.denpyoBiko8,
          biko: e.uketsukeBiko
        }
        this.$nextTick(() => { this.isLoading = false })
      }
      this.isShowToritsukesakiSearchDialog = false
    },
    onSagyobashoSearchButtonClick: function () {
      if ([undefined, null, ''].includes(this.rec.trJuchuMeisai.toritsukesaki)) {
        modals.showConfirm('TGRCOQ04').then((ok) => {
          if (ok !== false && ok !== undefined) {
            this.isShowSagyobashoSearchDialog = true
          }
        })
      } else {
        this.isShowSagyobashoSearchDialog = true
      }
    },
    onSagyobashoSearchDialogClose: function (e) {
      console.log(e)
      if (e !== null) {
        this.isLoading = true
        this.rec.trJuchuMeisai = {
          ...this.rec.trJuchuMeisai,
          sagyobashoYubinNo: e.sagyobashoYubinNo,
          sagyobashoJusho1: e.sagyobashoJusho1,
          sagyobashoJusho2: e.sagyobashoJusho2,
          sagyobashoJusho3: e.sagyobashoJusho3
        }
        this.$nextTick(() => { this.isLoading = false })
      }
      this.isShowSagyobashoSearchDialog = false
    },
    onPopupOptionSagyoOpen: function () {
      console.log('onPopupOptionSagyoOpen', this.rows.optionSagyoRows)
      this.isShowPopupOptionSagyo = true
    },
    onPopupOptionSagyoClose: function () {
      this.isShowPopupOptionSagyo = false
    },
    onClickOptionSagyoDelete: function () {
      this.rows.optionSagyoRows = []
    },
    onPopupOptionSagyoSelect: function (e) {
      console.log('onPopupOptionSagyoSelect', e)
      this.rows.optionSagyoRows = []
      this.rows.optionSagyoRows = e

      // 表示用請求金額の設定
      for (let x = 0; x < this.rows.optionSagyoRows.length; x++) {
        this.rows.optionSagyoRows[x].seikyuKingakuDisp = (this.rows.optionSagyoRows[x].seikyuKingaku) ? filter.numericFormatter(formatter.removeComma(this.rows.optionSagyoRows[x].seikyuKingaku)) : '0'
        this.rows.optionSagyoRows[x].shiharaiKingakuDisp = (this.rows.optionSagyoRows[x].shiharaiKingaku) ? filter.numericFormatter(formatter.removeComma(this.rows.optionSagyoRows[x].shiharaiKingaku)) : '0'
      }

      // 作成済み車両のオプション作業を更新
      for (let i = 0; i < this.rows.sharyoRows.length; i++) {
        if (this.refreshSharyoOptionList(i)) {
          this.rows.sharyoRows[i].editFlg = true
        }
      }

      this.isShowPopupOptionSagyo = false
    },
    refreshSharyoOptionList: function (index) {
      // 車両用オプション作業更新
      var rtn = false

      // 不足分の追加
      for (let m = 0; m < this.rows.optionSagyoRows.length; m++) {
        const existIndex = (this.rows.sharyoOptionRows) ? this.rows.sharyoOptionRows.findIndex((elem) => elem.keyNo === this.rows.sharyoRows[index].keyNo && elem.mstHinmeiId === this.rows.optionSagyoRows[m].mstHinmeiId) : -1
        if (existIndex < 0) {
          var recOption = {
            keyNo: this.rows.sharyoRows[index].keyNo,
            hinshuSbt: this.rows.optionSagyoRows[m].hinshuSbt,
            mstHinmeiId: this.rows.optionSagyoRows[m].mstHinmeiId,
            hinmeiCd: this.rows.optionSagyoRows[m].hinmeiCd,
            hinmeiNm: this.rows.optionSagyoRows[m].hinmeiNm,
            juchuSuryo: (this.rows.optionSagyoRows[m].juchuSuryo) ? this.rows.optionSagyoRows[m].juchuSuryo : this.rows.sharyoRows[index].juchuSuryo,
            shohinTanka: ![null, 0, ''].includes(this.rows.optionSagyoRows[m].juchuSuryo) && ![null, 0, ''].includes(this.rows.optionSagyoRows[m].seikyuKingaku) ? formatter.removeComma(this.rows.optionSagyoRows[m].seikyuKingaku) / this.rows.optionSagyoRows[m].juchuSuryo : 0,
            seikyuKingaku: (this.rows.optionSagyoRows[m].seikyuKingaku) ? formatter.removeComma(this.rows.optionSagyoRows[m].seikyuKingaku) : formatter.removeComma(this.rows.sharyoRows[index].seikyuKingaku),
            shiharaiKingaku: (this.rows.optionSagyoRows[m].shiharaiKingaku) ? formatter.removeComma(this.rows.optionSagyoRows[m].shiharaiKingaku) : formatter.removeComma(this.rows.sharyoRows[index].shiharaiKingaku),
            seikyuKingakuDisp: (this.rows.optionSagyoRows[m].seikyuKingaku) ? this.rows.optionSagyoRows[m].seikyuKingaku : this.rows.sharyoRows[index].seikyuKingaku,
            shiharaiKingakuDisp: (this.rows.optionSagyoRows[m].shiharaiKingaku) ? this.rows.optionSagyoRows[m].shiharaiKingaku : this.rows.sharyoRows[index].shiharaiKingaku,
            sagyoHyojiOrder: this.rows.optionSagyoRows[m].sagyoHyojiOrder,
            hyojiOrder: this.rows.optionSagyoRows[m].hyojiOrder,
            updDate: null
          }
          this.rows.sharyoOptionRows.push(recOption)
          rtn = true
        }
      }

      // 既存分の削除
      const self = this
      const x = self.rows.sharyoOptionRows.filter((elem) => elem.keyNo === self.rows.sharyoRows[index].keyNo)
      for (let m = 0; m < x.length; m++) {
        const existIndex = self.rows.optionSagyoRows.findIndex((elem) => elem.mstHinmeiId === x[m].mstHinmeiId)
        if (existIndex < 0) {
          const deleteIndex = self.rows.sharyoOptionRows.findIndex((elem) => elem.keyNo === x[m].keyNo && elem.mstHinmeiId === x[m].mstHinmeiId)
          self.rows.sharyoOptionRows.splice(deleteIndex, 1)
          rtn = true
        }
      }

      return rtn
    },
    // 金額計算
    calcSeikyuKingaku (e, item) {
      console.log('calcSeikyuKingaku item is', item)
      // 数量0の場合、支払金額初期化
      if ([undefined, null, '0', ''].includes(item.juchuSuryo)) item.shiharaiKingaku = item.shiharaiKingaku > 0 ? 0 : null

      if ([undefined, null, '0', ''].includes(item.juchuSuryo) || [undefined, null, '0', ''].includes(item.shohinTankaDisp)) return
      item.seikyuKingaku = formatter.removeComma(item.juchuSuryo) * formatter.removeComma(item.shohinTankaDisp)
    },
    calcSeikyuTanka (e, item) {
      console.log('calcSeikyuTanka item is', item)
      if ([undefined, null, '0', ''].includes(item.juchuSuryo) || [undefined, null, '0', ''].includes(item.seikyuKingaku)) return
      item.shohinTanka = formatter.removeComma(item.seikyuKingaku) / formatter.removeComma(item.juchuSuryo)
      item.shohinTankaDisp = filter.numericFormatter(item.shohinTanka)
    },

    onPopupBuzaiOpen: function () {
      console.log('onPopupBuzaiOpen', this.rows.sagyoBuzaiRows)
      this.isBuzaiLoading = true
      this.isShowPopupBuzai = true
    },
    onPopupBuzaiClose: function () {
      this.isBuzaiLoading = false
      this.isShowPopupBuzai = false
    },
    onPopupBuzaiSelect: function (e) {
      console.log('onPopupBuzaiSelect', e)
      this.isBuzaiLoading = false
      this.rows.sagyoBuzaiRows = []
      this.rows.sagyoBuzaiRows = e

      // 作成済み車両のオプション作業を更新
      for (let i = 0; i < this.rows.sharyoRows.length; i++) {
        if (this.refreshSharyoBuzaiList(i)) {
          this.rows.sharyoRows[i].editFlg = true
        }
      }

      this.isShowPopupBuzai = false
    },
    refreshSharyoBuzaiList: function (index) {
      // 車両用部材更新
      var rtn = false

      // 不足分の追加
      for (let m = 0; m < this.rows.sagyoBuzaiRows.length; m++) {
        const existIndex = (this.rows.sharyoBuzaiRows) ? this.rows.sharyoBuzaiRows.findIndex((elem) => elem.keyNo === this.rows.sharyoRows[index].keyNo && elem.mstHinmeiId === this.rows.sagyoBuzaiRows[m].mstHinmeiId) : -1
        if (existIndex < 0) {
          var recOption = {
            keyNo: this.rows.sharyoRows[index].keyNo,
            hinshuSbt: this.rows.sagyoBuzaiRows[m].hinshuSbt,
            mstHinmeiId: this.rows.sagyoBuzaiRows[m].mstHinmeiId,
            hinmeiCd: this.rows.sagyoBuzaiRows[m].hinmeiCd,
            hinmeiNm: this.rows.sagyoBuzaiRows[m].hinmeiNm,
            juchuSuryo: (this.rows.sagyoBuzaiRows[m].juchuSuryo) ? this.rows.sagyoBuzaiRows[m].juchuSuryo : this.rows.sharyoRows[index].juchuSuryo,
            shohinTanka: ![null, 0, ''].includes(this.rows.sagyoBuzaiRows[m].juchuSuryo) && ![null, 0, ''].includes(this.rows.sagyoBuzaiRows[m].seikyuKingaku) ? formatter.removeComma(this.rows.sagyoBuzaiRows[m].seikyuKingaku) / this.rows.sagyoBuzaiRows[m].juchuSuryo : 0,
            seikyuKingaku: (this.rows.sagyoBuzaiRows[m].seikyuKingaku) ? formatter.removeComma(this.rows.sagyoBuzaiRows[m].seikyuKingaku) : formatter.removeComma(this.rows.sharyoRows[index].seikyuKingaku),
            updDate: null,
            buzaiIcon: this.rows.sagyoBuzaiRows[m].buzaiIcon,
            buzaiDescription: this.rows.sagyoBuzaiRows[m].buzaiDescription,
            color: this.rows.sagyoBuzaiRows[m].color
          }
          this.rows.sharyoBuzaiRows.push(recOption)
          rtn = true
        }
      }

      // 既存分の削除
      const self = this
      const x = self.rows.sharyoBuzaiRows.filter((elem) => elem.keyNo === self.rows.sharyoRows[index].keyNo)
      for (let m = 0; m < x.length; m++) {
        const existIndex = self.rows.sagyoBuzaiRows.findIndex((elem) => elem.mstHinmeiId === x[m].mstHinmeiId)
        if (existIndex < 0) {
          const deleteIndex = self.rows.sharyoBuzaiRows.findIndex((elem) => elem.keyNo === x[m].keyNo && elem.mstHinmeiId === x[m].mstHinmeiId)
          self.rows.sharyoBuzaiRows.splice(deleteIndex, 1)
          rtn = true
        }
      }
      return rtn
    },

    onSeikyuKingakuInputFocus: function () {
      this.savedSeikyuKingaku = this.kihonSagyoSeikyuKingaku
    },
    onSeikyuKingakuInputBlur: function () {
      // 入力がない場合は0に置き換え
      if ([null, ''].includes(this.kihonSagyoSeikyuKingaku)) this.kihonSagyoSeikyuKingaku = 0

      if (this.savedSeikyuKingaku !== this.kihonSagyoSeikyuKingaku) {
        console.log('onSeikyuKingakuInputBlur', this.savedSeikyuKingaku, this.kihonSagyoSeikyuKingaku)
        this.rows.sharyoKihonRows.filter((elem) => {
          return elem.mstHinmeiId === 19999
        }).forEach((item) => {
          item.seikyuKingaku = this.kihonSagyoSeikyuKingaku
        })
      }
    },

    /* ================================================================================ *
     * 作業車両
     * ================================================================================ */
    onBatchDownloadCheckSheet: function (e) {
      this.isCheckSheetDownload = true

      // ZIPファイル名生成
      const torihikisakiNm = indexeddb.getRecord(this.torihikisakiList, this.rec.trJuchuKihon.tokuisakiId).torihikisakiNm
      const gnereNm = this.rec.trJuchuMeisai.denpyoHanyoSbt4 !== null ? '_' + indexeddb.getShubetsu('0010', this.shubetsuList, 'TGS003', this.rec.trJuchuMeisai.denpyoHanyoSbt4).sbtNm : ''
      const toritsukesaki = this.rec.trJuchuMeisai.toritsukesaki
      const zipFileNmae = 'チェックシート' + gnereNm + '_' + torihikisakiNm + '_' + toritsukesaki + '.zip'

      const self = this
      this.HttpClient
        .requestFileByPost(`/api/v1/vwCTgrcod002080/batchDownload?id=${self.id}`)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/zip' })
          const elem = document.getElementById('batchDownload')
          this.isCheckSheetDownload = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = zipFileNmae
          elem.click()
        })
    },
    onBatchDownloadReceipt: function (e) {
      this.isReceiptDownload = true

      // ZIPファイル名生成
      const torihikisakiNm = indexeddb.getRecord(this.torihikisakiList, this.rec.trJuchuKihon.tokuisakiId).torihikisakiNm
      const gnereNm = this.rec.trJuchuMeisai.denpyoHanyoSbt4 !== null ? '_' + indexeddb.getShubetsu('0010', this.shubetsuList, 'TGS003', this.rec.trJuchuMeisai.denpyoHanyoSbt4).sbtNm : ''
      const toritsukesaki = this.rec.trJuchuMeisai.toritsukesaki
      const zipFileNmae = '領収書' + gnereNm + '_' + torihikisakiNm + '_' + toritsukesaki + '.zip'

      const self = this
      this.HttpClient
        .requestFileByPost(`/api/v1/vwCTgrcod002080/ReceiptBatchDownload?id=${self.id}`)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/zip' })
          const elem = document.getElementById('batchDownload')
          this.isReceiptDownload = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = zipFileNmae
          elem.click()
        })
    },
    onBatchDownloadPicture: function (e) {
      this.isPictureDownload = true

      // ZIPファイル名生成
      const torihikisakiNm = indexeddb.getRecord(this.torihikisakiList, this.rec.trJuchuKihon.tokuisakiId).torihikisakiNm
      const gnereNm = this.rec.trJuchuMeisai.denpyoHanyoSbt4 !== null ? '_' + indexeddb.getShubetsu('0010', this.shubetsuList, 'TGS003', this.rec.trJuchuMeisai.denpyoHanyoSbt4).sbtNm : ''
      const toritsukesaki = this.rec.trJuchuMeisai.toritsukesaki
      const zipFileNmae = '画像ファイル' + gnereNm + '_' + torihikisakiNm + '_' + toritsukesaki + '.zip'

      const self = this
      this.HttpClient
        .requestFileByPost(`/api/v1/vwCTgrcod002081/batchDownload?id=${self.id}`)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/zip' })
          const elem = document.getElementById('batchDownload')
          this.isPictureDownload = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = zipFileNmae
          elem.click()
        })
    },
    onSagyoSharyoAppend: function (e) {
      // KeyNoの最大値を取得
      var maxKeyNo = 0
      for (let x = 0; x < this.rows.sharyoRows.length; x++) {
        if (maxKeyNo < this.rows.sharyoRows[x].keyNo) maxKeyNo = this.rows.sharyoRows[x].keyNo
      }
      this.appendSharyo(this.rows.sharyoRows.length, 1, maxKeyNo)
    },
    onSagyoSharyoCreate: function (e) {
      if ((this.mitsumoriIraiDaisu === null) || this.mitsumoriIraiDaisu < 1) {
        modals.showError('依頼台数を入力してください')
        return false
      } else {
        // 車両台数に現在値を保存
        this.sharyoDaisu = this.mitsumoriIraiDaisu
        // KeyNoの最大値を取得
        var maxKeyNo = 0
        for (let x = 0; x < this.rows.sharyoRows.length; x++) {
          if (maxKeyNo < this.rows.sharyoRows[x].keyNo) maxKeyNo = this.rows.sharyoRows[x].keyNo
        }

        // 車両行を作成
        var invalidCount = this.rows.sharyoRows.filter((elem) => {
          return elem.delFlg === true || (elem.sagyoCancelFlg === true && elem.sagyoKanryoFlg === false)
        }).length

        var startSharyoIdx = this.rows.sharyoRows.length
        var maxSharyoCount = Number(this.sharyoDaisu) + Number(invalidCount)
        if (this.availableSharyoCount < this.sharyoDaisu) {
          for (let i = startSharyoIdx, xx = 1; i < maxSharyoCount; i++, xx++) {
            this.appendSharyo(i, xx, maxKeyNo)
          }
        }
      }
      return true
    },
    appendSharyo: function (i, xx, maxKeyNo) {
      var recSharyo = {
        editFlg: true,
        id: (i + 1) * -1,
        trJuchuMeisaiId: '',
        trSagyoMeisaiExtTgId: '',
        trJuchusagyoRelationId: '',
        trHacchusagyoRelationId: '',
        trHacchuKihonId: '',
        trSasgyoJissekiSagyoRelatonId: '',
        trSagyoJissekiId: '',
        keyNo: (maxKeyNo + xx),
        oldShabanPlateNo: '',
        oldShadaiNo: '',
        newShabanPlateNo: '',
        newShadaiNo: '',
        sharyoKeishiki: '',
        shonendoToroku: '',
        sharyoMaker: null,
        sharyoMakerNm: '',
        shashu: '',
        backeyeKeishiki: null,
        backeyeKeishikiNm: '',
        etcKanriNo: '',
        etcKeishiki: null,
        etcKeishikiNm: '',
        refrigeratorMaker: null,
        refrigeratorMakerNm: '',
        oldSerialNo: '',
        newSerialNo: '',
        doorNo: '',
        sagyoSbt: this.rec.trJuchuMeisai.denpyoHanyoSbt2,
        shohinId: this.rec.trJuchuMeisai.shohinId,
        shohinNm: '',
        iraisakiId: '',
        iraisakiNm: '',
        sagyoTantoshaId: '',
        sagyoTantoshaNm: '',
        sagyoYoteiYmd: '',
        jissekiSagyoYmd: '',
        imageCount: '',
        sagyoKanryoFlg: this.rec.trJuchuMeisai.denpyoHanyoSbt2 === '04',
        sagyoCancelFlg: false,
        unchinCheckYmd: '',
        unchinCheckTantoshaId: '',
        unchinCheckTantoshaNm: '',
        uriageKakuteiFlg: false,
        uriageKakuteiYmd: null,
        uriageKakuteiTantoshaId: '',
        uriageKakuteiTantoshaNm: '',
        notYayoiRenkeiFlg: false,
        matomeSeikyuFlg: false,
        sagyoMemo: '',
        iraisakiRenrakuMemo: '',
        sharyoBiko: '',
        updDate: null,
        smexUpdDate: null,
        jsrUpdDate: null,
        hsrUpdDate: null,
        sjrUpdDate: null,
        hkUpdDate: null,
        sjUpdDate: null,
        delFlg: false,
        // ↓以下表示のみ項目
        seikyuSagyoKingakuKei: null,
        seikyuBuzaiKingakuKei: null,
        shiharaiSagyoKingakuKei: null
      }
      this.rows.sharyoRows.push(recSharyo)

      // 基本作業作成 ※初回のみ
      const kihonSagyo = this.rows.kihonSagyoRows
      if (kihonSagyo.length > 0) {
        kihonSagyo.forEach((item) => {
          var recKihon = {
            keyNo: this.rows.sharyoRows[i].keyNo,
            hinshuSbt: item.hinshuSbt,
            mstHinmeiId: item.mstHinmeiId,
            hinmeiCd: item.hinmeiCd,
            hinmeiNm: item.hinmeiNm,
            juchuSuryo: 1,
            shohinTanka: item.mstHinmeiId === 19999 ? formatter.removeComma(this.kihonSagyoSeikyuKingaku) : 0,
            seikyuKingaku: item.mstHinmeiId === 19999 ? formatter.removeComma(this.kihonSagyoSeikyuKingaku) : 0,
            shiharaiKingaku: item.mstHinmeiId === 19999 ? formatter.removeComma(this.kihonSagyoShiharaiKingaku) : 0,
            updDate: null
          }
          this.rows.sharyoKihonRows.push(recKihon)
        })

        if (this.rec.trJuchuMeisai.denpyoHanyoSbt2 === '04') {
          // 受付作業完了反映
          this.syncSagyoKanryo()
        }
      }

      // オプション作業作成
      this.refreshSharyoOptionList(i)
      // 部材作成
      this.refreshSharyoBuzaiList(i)
    },
    onPopupSagyoSharyoListClose: function () {
      this.isShowPopupSagyoSharyoList = false
    },
    onPopupSagyoSharyoListOpen: function () {
      if (this.sharyoDaisu === this.mitsumoriIraiDaisu) {
        this.sagyoSharyoListParam = {
          jishaDenpyoNo: this.rec.trJuchuMeisai.jishaDenpyoNo,
          tokuisakiId: this.rec.trJuchuKihon.tokuisakiId,
          toritsukesakiNm: this.rec.trJuchuMeisai.toritsukesaki,
          eigyosho: this.rec.trJuchuMeisai.denpyoBiko1,
          jenreCd: this.rec.trJuchuMeisai.denpyoHanyoSbt4,
          sagyoKbn: this.rec.trJuchuMeisai.denpyoHanyoSbt2,
          shohinId: this.rec.trJuchuMeisai.shohinId,
          rownum: this.mitsumoriIraiDaisu
        }
        this.isShowPopupSagyoSharyoList = true
      } else {
        modals.showError('依頼台数が ' + this.sharyoDaisu + ' 台から ' + this.mitsumoriIraiDaisu + ' 台に変更されています<br>[車両作成]ボタンを押して台数を確定してください')
      }
    },
    onPopuoSagyoSharyoListEdited: function (x, a, b, c) {
      console.log('onPopuoSagyoSharyoListEdited', x)
      this.rows.sharyoRows = []
      this.rows.sharyoRows = x
      this.rows.sharyoKihonRows = a
      this.rows.sharyoOptionRows = b
      this.rows.sharyoBuzaiRows = c
      this.isShowPopupSagyoSharyoList = false

      // 受付作業完了反映
      this.syncSagyoKanryo()
      // 受付運賃確定反映
      this.syncUnchinKakutei()
    },
    onPopuoSagyoSharyoListSaveReqested: function (x, a, b, c, s) {
      console.log('onPopuoSagyoSharyoListSaveReqested', s)
      // 画面の内容を反映
      this.rows.sharyoRows = []
      this.rows.sharyoRows = x
      this.rows.sharyoKihonRows = a
      this.rows.sharyoOptionRows = b
      this.rows.sharyoBuzaiRows = c
      this.isShowPopupSagyoSharyoList = false

      // 保存処理実行
      this.save(false, false).then(() => {
        // 新規車両用ID更新
        s.forEach((item) => {
          if (item.id < 0) {
            const index = this.rows.sharyoRows.findIndex((elem) => elem.keyNo === item.keyNo)
            if (index > 0) {
              item.id = this.rows.sharyoRows[index].id
            }
          }
        })

        // 作業依頼画面呼び出し
        this.sagyoIraiId = 0
        this.iraiMailId = -1
        this.sagyoIraiParam = {
          ...this.sagyoIraiParam,
          sagyoKbn: this.rec.trJuchuMeisai.denpyoHanyoSbt2,
          sagyobashoYubinNo: this.rec.trJuchuMeisai.sagyobashoYubinNo,
          sagyobashoJusho1: this.rec.trJuchuMeisai.sagyobashoJusho1,
          sagyobashoJusho2: this.rec.trJuchuMeisai.sagyobashoJusho2,
          sagyobashoJusho3: this.rec.trJuchuMeisai.sagyobashoJusho3,
          hatsuchiYmd: this.rec.trJuchuMeisai.hatsuchiYmd,
          chakuchiYmd: this.rec.trJuchuMeisai.chakuchiYmd,
          toritsukesakiNm: this.rec.trJuchuMeisai.toritsukesaki,
          unchinKakuteiFlg: this.cloneSeikyuKakuteiFlg,
          seikyuRank: this.rec.trJuchuMeisai.denpyoHanyoSbt3
        }
        this.seletedSharyoList = s
        this.isShowPopupSagyoIraiEdit = true
      })
    },
    onPopuoSagyoSharyoListReqested: function (s) {
      console.log('onPopuoSagyoSharyoListReqested', s)
      this.isShowPopupSagyoSharyoList = false

      // 作業依頼画面呼び出し
      this.sagyoIraiId = 0
      this.iraiMailId = -1
      this.sagyoIraiParam = {
        ...this.sagyoIraiParam,
        sagyoKbn: this.rec.trJuchuMeisai.denpyoHanyoSbt2,
        sagyobashoYubinNo: this.rec.trJuchuMeisai.sagyobashoYubinNo,
        sagyobashoJusho1: this.rec.trJuchuMeisai.sagyobashoJusho1,
        sagyobashoJusho2: this.rec.trJuchuMeisai.sagyobashoJusho2,
        sagyobashoJusho3: this.rec.trJuchuMeisai.sagyobashoJusho3,
        hatsuchiYmd: this.rec.trJuchuMeisai.hatsuchiYmd,
        chakuchiYmd: this.rec.trJuchuMeisai.chakuchiYmd,
        toritsukesakiNm: this.rec.trJuchuMeisai.toritsukesaki,
        unchinKakuteiFlg: this.cloneSeikyuKakuteiFlg,
        seikyuRank: this.rec.trJuchuMeisai.denpyoHanyoSbt3
      }
      this.seletedSharyoList = s
      this.isShowPopupSagyoIraiEdit = true
    },
    onPopuoSagyoSharyoListImport: function (x, a, b, c) {
      console.log('onPopuoSagyoSharyoListImport')
      // 画面の内容を反映
      this.rows.sharyoRows = []
      this.rows.sharyoRows = x
      this.rows.sharyoKihonRows = a
      this.rows.sharyoOptionRows = b
      this.rows.sharyoBuzaiRows = c

      // 保存処理実行
      this.save(false, false).then(() => {
        return true
      })
    },

    onSharyoRowDoubleClick: function (index) {
      this.onPopupSagyoSharyoEditOpen(index)
    },
    onPopupSagyoSharyoEditClose: function () {
      this.isShowPopupSagyoSharyoEdit = false
    },
    onPopupSagyoSharyoEditOpen: function (rowIndex) {
      this.sharyoId = this.rows.sharyoRows[rowIndex - 1].id
      this.sharyoParam = {
        ...this.sharyoParam,
        chumonNo: [undefined, null, ''].includes(this.rec.trJuchuKihon.chumonNo) ? this.rec.trJuchuMeisai.jishaDenpyoNo : this.rec.trJuchuKihon.chumonNo,
        toritsukesaki: this.rec.trJuchuMeisai.toritsukesaki,
        unchinKakuteiFlg: this.cloneSeikyuKakuteiFlg,
        seikyuRank: null,
        jenreCd: this.rec.trJuchuMeisai.denpyoHanyoSbt4,
        sagyoKbn: this.rec.trJuchuMeisai.denpyoHanyoSbt2,
        shohinId: this.rec.trJuchuMeisai.shohinId,
        uketsukeSharyoList: Object.assign([], this.rows.sharyoRows),
        uketsukeKihonList: Object.assign([], this.rows.sharyoKihonRows),
        uketsukeSagyoList: Object.assign([], this.rows.sharyoOptionRows),
        uketsukeBuzaiList: Object.assign([], this.rows.sharyoBuzaiRows),
        index: rowIndex - 1
      }
      this.isShowPopupSagyoSharyoEdit = true
    },
    onSharyoDelete: function (item) {
      const index = this.rows.sharyoRows.findIndex((elem) => elem.id === item.id)
      this.rows.sharyoRows[index].delFlg = !this.rows.sharyoRows[index].delFlg
      this.rows.sharyoRows[index].editFlg = true
      this.rows.sharyoRows.splice()

      // 依頼台数再計算
      this.calcSharyoDaisu(index)
    },
    onSharyoEdited: function (x, a, b, c) {
      console.log('onSharyoEdited', x, a, b, c)
      this.rows.sharyoRows = []
      this.rows.sharyoRows = x
      this.rows.sharyoKihonRows = a
      this.rows.sharyoOptionRows = b
      this.rows.sharyoBuzaiRows = c
      this.isShowPopupSagyoSharyoEdit = false

      // 依頼台数再計算
      this.rows.sharyoRows.forEach((item, index) => {
        if (item.delFlg) {
          this.calcSharyoDaisu(index)
        }
      })
      // 受付作業完了反映
      this.syncSagyoKanryo()
      // 受付運賃確定反映
      this.syncUnchinKakutei()
    },
    syncSagyoKanryo: function () {
      const target = this.rows.sharyoRows.find((item) => item.sagyoKanryoFlg === false && item.sagyoCancelFlg === false)
      // 全て完了済みの場合のみ受付の作業完了とする
      if (target) {
        this.rec.trJuchuMeisai.sagyoNaiyoKakuteiFlg = false
      } else {
        this.rec.trJuchuMeisai.sagyoNaiyoKakuteiFlg = true
        this.rec.trJuchuMeisai.sagyoNaiyoKakuteiTantoshaId = this.loginUserId
        this.rec.trJuchuMeisai.sagyoNaiyoKakuteiYmd = filter.dateFormatter(new Date())
      }
    },
    syncUnchinKakutei: function () {
      const target = this.rows.sharyoRows.find((item) => item.uriageKakuteiFlg === false && item.sagyoCancelFlg === false)
      // 全て完了済みの場合のみ受付の作業完了とする
      if (target) {
        this.rec.trJuchuMeisai.unchinKakuteiFlg = false
      } else {
        this.rec.trJuchuMeisai.unchinKakuteiFlg = true
        this.rec.trJuchuMeisai.unchinCheckTantoshaId = this.loginUserId
        this.rec.trJuchuMeisai.unchinCheckYmd = filter.dateFormatter(new Date())
      }
    },
    calcSharyoDaisu (index) {
      if (this.rows.sharyoRows[index].delFlg) {
        if (this.mitsumoriIraiDaisu > this.availableSharyoCount) {
          this.mitsumoriIraiDaisu -= 1
        }
      } else {
        if (this.mitsumoriIraiDaisu <= this.availableSharyoCount) {
          this.mitsumoriIraiDaisu += 1
        }
      }
      this.sharyoDaisu = this.mitsumoriIraiDaisu
    },
    onImageOpenButtonClick: function (item) {
      console.log('onImageOpenButtonClick : ', item)
    },

    // ----------------------------------------------------------------------------------------------------
    // フッターボタン制御
    // ----------------------------------------------------------------------------------------------------
    onDialogCloseClick: function () {
      return true
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: parseInt(self.backActionNo, 10),
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    /*
      // 遷移前変更チェック
      const target = this.getCloneTargetMethod()
      const modified = this._compareClone(target)
      const p = modified ? modals.showConfirmSave : this._dummyPromiseMethod
      if (p !== this._dummyPromiseMethod) {
        p().then((pressedButton) => {
          if (pressedButton === 'not-save') {
            this.transitionView()
          } else if (pressedButton === 'save') {
            this.save(false, false).then(() => {
              this.transitionView()
            })
          }
          /*
          if (ok === false || ok === undefined) {
            this.transitionView()
          } else {
            this.save(false, false).then(() => {
              this.transitionView()
            })
          }
          *
        })
      } else {
        this.transitionView()
      }
    },
    */
    transitionView: function () {
      // 画面遷移
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: parseInt(self.backActionNo, 10),
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = self.cloneData.rec
            self.rows = self.cloneData.rows
            self.mitsumoriIraiDaisu = self.cloneData.mitsumoriIraiDaisu
            self.sharyoDaisu = self.cloneData.sharyoDaisu
            resolve()
          })
        }
      }
      this.cancelInputs(opt)
    },
    /**
     * 削除
     */
    onDeleteButtonClick: function () {
      // modals.showToast('現在未実装です', 2000, 400, null, 'error')
      const clone = this.cloneData
      clone.rows.sharyoRows.forEach((item) => {
        if (item.sagyoKanryoFlg) {
          modals.showAlert('TGRCOE13')
          return false
        }
        if (item.uriageKakuteiFlg) {
          modals.showAlert('TGRCOE14')
          return false
        }
      })
      modals.showConfirm('COMQ0003').then((ok) => {
        if (ok !== false && ok !== undefined) {
          this.delete()
        }
      })
      return true
    },
    delete: function (e) {
      console.log('delete')
      const self = this
      if (this.validateAll(this.$refs) && self.deleteValidate()) {
        this.Effects.loadStart()

        // SummaryMessage初期化
        if (!this.isDialog) this.clearSummaryMessage()
        self.rec = self.cloneData.rec

        return new Promise(resolve => {
          this.HttpClient.post(`/api/v1/Tgrcod0020/DeleteWithChildren?id=${self.id}`, self.rec).then(data => {
            if (!data.isValid) {
              self.showMessage(data)
              this.setInvalidMessage(this.$refs, data.invalidList)
              this.Effects.loadComplete()
              resolve()
            } else {
              modals.showToastMessage('COMI0003')
              this.transitionView()
              resolve()
            }
          }).catch((e) => {
            console.log('error', e)
            modals.showError(e.message)
            this.Effects.loadComplete()
            resolve()
          })
        })
      }
    },
    deleteValidate: function () {
      return true
    },
    /**
     * 複写
     */
    onCopyButtonClick: function () {
      const p = modals.showConfirm
      p('TGRCOQ06').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()

        const currentData = this.rec
        this.clear()
        // 受注情報のみ複写
        this.rec.trJuchuKihon = currentData.trJuchuKihon
        this.rec.trJuchuMeisai = currentData.trJuchuMeisai
        // キー情報初期化
        this.id = 0
        this.rec.trJuchuKihon.id = 0
        this.rec.trJuchuKihon.juchuYmd = date.getCurrentDate()
        this.rec.trJuchuMeisai.id = 0
        this.rec.trJuchuMeisai.extId = 0
        this.rec.trJuchuMeisai.kingakuId = 0
        this.rec.trJuchuMeisai.trJuchuKihonId = 0
        this.rec.trJuchuMeisai.jishaDenpyoNo = null
        this.rec.trJuchuKihon.chumonNo = null
        this.rec.trJuchuMeisai.hatsuchiYmd = null
        this.rec.trJuchuMeisai.chakuchiYmd = null
        this.rec.trJuchuMeisai.sagyoNaiyoKakuteiFlg = false
        this.rec.trJuchuMeisai.unchinKakuteiFlg = false
        this.rec.trJuchuMeisai.cancelFlg = false
        this.rec.trJuchuMeisai.cancelText = null
        this.rec.trJuchuMeisai.seikyuTomeFlg = false
        this.rec.trJuchuMeisai.seikyuBiko = null

        // 得意先の変更忘れを防ぐために初期化
        this.rec.trJuchuKihon.tokuisakiId = null

        // 特殊取付先の場合は会社コードをNULLにする
        if (this.rec.trJuchuMeisai.toritsukesaki.indexOf(SP_TORITSUKESAKI_1) >= 0) this.rec.trJuchuMeisai.denpyoBiko6 = null

        // 基本作業初期化
        this.mitsumoriIraiDaisu = 0
        this.sharyoDaisu = this.mitsumoriIraiDaisu

        // 基本・オプション作業
        // 品目は作業がない場合のみ複写
        currentData.trJuchuHinmoku.forEach((item) => {
          const m = this.tgMstHinmeiList.find((m) => m.mstHinmeiId === item.mstHinmeiId)
          // 部材は除外する
          if (!['04', '05', '06'].includes(m.hinshuSbt)) {
            const tmpJuchuHinmoku = {
              id: 0,
              mstHinmeiId: item.mstHinmeiId,
              juchuSuryo: item.juchuSuryo,
              kihonUnchin: item.kihonUnchin,
              UserKingakuKazei1: item.UserKingakuKazei1,
              hinmeiCd: item.hinmeiCd,
              hinmeiNm: item.hinmeiNm,
              hinmeiBiko: item.hinmeiBiko,
              hinban: item.hinban,
              katashiki: item.katashiki,
              hinshuSbt: m.hacchusakiHinshuKbn,
              // オプション作業フィルタ用
              hinmokuSbt: m.hacchusakiHinshuKbn
            }
            this.rec.trJuchuHinmoku.push(tmpJuchuHinmoku)
          }
        })

        // 信号設定
        this.rows.signalItems = this.filteredSignalItems
        this.rows.signalItems.map((elem) => {
          const t = (this.rec.trJuchuHinmoku || this.rec.trJuchuHinmoku.length > 0) ? this.rec.trJuchuHinmoku.find((item) => item.mstHinmeiId === elem.mstHinmeiId) : undefined
          // 未登録時のみ01:常時,02:ACCを初期セット
          elem.value = t !== undefined
        })
        this.rows.kihonSagyoRows = this.filteredKihonSagyoRows
        // オプション作業
        this.rows.optionSagyoRows = this.filteredOptionSagyoRows

        this.Effects.loadComplete()
      })
    },
    /**
     * 新規
     */
    onNewButtonClick: function () {
      console.log('NewButton pushed')
      const p = modals.showConfirm
      p('TGRCOQ07').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()

        this.id = 0
        this.clear()
        this.setCloneData()
        this.modeOfEdit = 0 // 新規モードに切り替え

        this.Effects.loadComplete()
      })
    },
    /**
     * 保存
     * @returns
     */
    onSaveButtonClick: function () {
      this.save(false, true)
      return true
    },

    // ****************************************************************************************************
    // 受付保存処理
    // ****************************************************************************************************
    save: function (isClose, isSaveMessage) {
      return new Promise(resolve => {
        const self = this
        if (this.validateAll(this.$refs) && self.registerValidate()) {
          this.Effects.loadStart()
          self.registerPromise().then(data => {
            console.log('registerRequestPromise', data)

            if (!data.isValid) {
              this.Effects.loadComplete()
              this.showMessage(data)
              this.setInvalidMessage(this.$refs, data.invalidList)
              resolve(false)
            } else {
              this.Effects.loadComplete()
              if (isSaveMessage) {
                this.showToastMessage(data)
              }
              self.id = data.payload.item1.trJuchuMeisai.id
              self.modeOfEdit = 2 // 更新モードに切り替え
              self.savedResponse(data, isClose)
              resolve(true)
            }
          }).catch((e) => {
            console.log('error', e)
            this.Effects.loadComplete()
            modals.showError(e.message)
            resolve(false)
          })
        } else {
          resolve(false)
        }
      })
    },
    savedResponse: function (data, isClose) {
      this.assignData(data.payload)
      this.$store.dispatch('DDMasters/getKinoRecord', this.currentKinoId).then((k) => {
        console.log('registerRequestPromise', k)
        if (k.torokuOperationCtrlKbn === 'x') {
          console.error('msysKino.torokuOperationCtrlKbnに『x』が設定されています。')
        } else if (k.torokuOperationCtrlKbn === '1' || k.torokuOperationCtrlKbn === '2') {
          if (k.torokuOperationCtrlKbn === '2') {
            this.setCloneData()
          }
          this.Effects.loadComplete()
        } else {
          this.Effects.loadComplete()
        }
      })
    },
    /* ======================================================================================================================== *
     *
     * テーブル保存用マッピング
     *
     * ======================================================================================================================== */
    registerPromise: function () {
      console.log('★★★registerPromise★★★', this.id)
      const self = this
      const sendData = this.rec

      // --------------------------------------------------------------------------------
      // 受付情報
      // --------------------------------------------------------------------------------
      // 受注明細.荷主IDはAPI内Validateで必須
      sendData.trJuchuMeisai.ninushiId = this.rec.trJuchuKihon.tokuisakiId
      sendData.trJuchuKihon.seikyuTomeFlg = this.rec.trJuchuMeisai.seikyuTomeFlg
      sendData.trJuchuKihon.unchinKakuteiFlg = this.rec.trJuchuMeisai.unchinKakuteiFlg

      sendData.trSagyoMeisai.iraiDaisu = this.mitsumoriIraiDaisu

      // 作業確定及び請求に関する情報は未設定
      sendData.sagyoNaiyoKakuteiChangeFlg = this.cloneSagyoNaiyoKakuteiFlg !== this.rec.trJuchuMeisai.sagyoNaiyoKakuteiFlg
      sendData.seikyuKakuteiChangeFlg = this.cloneSeikyuKakuteiFlg !== this.rec.trJuchuMeisai.unchinKakuteiFlg
      sendData.trJuchuKihon.seikyuZumiFlg = false
      sendData.trJuchuKihon.seikyuYoteiYmd = null
      sendData.trJuchuMeisai.seikyuZumiFlg = false
      sendData.trJuchuMeisai.seikyuYoteiYmd = null

      // 品目編集領域定義
      const tmpJuchuHinmoku = []
      const tmpSagyoHinmoku = []

      // 信号
      this.rows.signalItems.forEach(function (item) {
        if (item.value) {
          const t = (sendData.trJuchuHinmoku) ? sendData.trJuchuHinmoku.find((x) => x.mstHinmeiId === item.mstHinmeiId) : undefined
          if (t === undefined) {
            tmpJuchuHinmoku.push({
              // trSagyoMeisai
              id: (t === undefined) ? 0 : t.id,
              sagyoHinmokuNo: (t === undefined) ? 0 : t.sagyoHinmokuNo,
              hinmokuSbt: '08',
              mstHinmeiId: item.mstHinmeiId,
              hinmeiBiko: item.hinmeiNm,
              juchuSuryo: 1,
              // trSagyoMeisaiExtTg
              extId: (t === undefined) ? 0 : t.extId,
              hinban: item.hinban,
              katashiki: item.Katashiki,
              // trSagyoKingaku
              kingakuId: (t === undefined) ? 0 : t.kingakuId
            })
          } else {
            tmpJuchuHinmoku.push(t)
          }
          const s = (sendData.trSagyoHinmoku) ? sendData.trSagyoHinmoku.find((x) => x.mstHinmeiId === item.mstHinmeiId) : undefined
          if (s === undefined) {
            tmpSagyoHinmoku.push({
              // trSagyoMeisai
              id: (s === undefined) ? 0 : s.id,
              sagyoHinmokuNo: (s === undefined) ? 0 : s.sagyoHinmokuNo,
              hinmokuSbt: '08',
              mstHinmeiId: item.mstHinmeiId,
              hinmeiBiko: item.hinmeiNm,
              juchuSuryo: 1,
              // trSagyoMeisaiExtTg
              extId: (s === undefined) ? 0 : s.extId,
              hinban: item.hinban,
              katashiki: item.Katashiki,
              // trSagyoKingaku
              kingakuId: (s === undefined) ? 0 : s.kingakuId
            })
          } else {
            tmpSagyoHinmoku.push(s)
          }
        }
      })
      // 基本作業
      this.rows.kihonSagyoRows.forEach(function (item) {
        const t = (sendData.trJuchuHinmoku) ? sendData.trJuchuHinmoku.find((x) => x.mstHinmeiId === item.mstHinmeiId) : undefined
        if (t === undefined) {
          tmpJuchuHinmoku.push({
            // trSagyoMeisai
            id: (t === undefined) ? 0 : t.id,
            sagyoHinmokuNo: (t === undefined) ? 0 : t.sagyoHinmokuNo,
            hinmokuSbt: '01',
            mstHinmeiId: item.mstHinmeiId,
            hinmeiBiko: item.hinmeiNm,
            juchuSuryo: 1,
            // trSagyoMeisaiExtTg
            extId: (t === undefined) ? 0 : t.extId,
            hinban: item.hinban,
            katashiki: item.Katashiki,
            // trSagyoKingaku
            kingakuId: (t === undefined) ? 0 : t.kingakuId,
            kihonUnchin: formatter.removeComma(item.seikyuKingaku),
            userKingakuKazei1: formatter.removeComma(item.shiharaiKingaku)
          })
        } else {
          tmpJuchuHinmoku.push(t)
        }
        const s = (sendData.trSagyoHinmoku) ? sendData.trSagyoHinmoku.find((x) => x.mstHinmeiId === item.mstHinmeiId) : undefined
        if (s === undefined) {
          tmpSagyoHinmoku.push({
            // trSagyoMeisai
            id: (s === undefined) ? 0 : s.id,
            sagyoHinmokuNo: (s === undefined) ? 0 : s.sagyoHinmokuNo,
            hinmokuSbt: '01',
            mstHinmeiId: item.mstHinmeiId,
            hinmeiBiko: item.hinmeiNm,
            juchuSuryo: 1,
            // trSagyoMeisaiExtTg
            extId: (s === undefined) ? 0 : s.extId,
            hinban: item.hinban,
            katashiki: item.Katashiki,
            // trSagyoKingaku
            kingakuId: (s === undefined) ? 0 : s.kingakuId,
            kihonUnchin: formatter.removeComma(item.seikyuKingaku),
            userKingakuKazei1: formatter.removeComma(item.shiharaiKingaku)
          })
        } else {
          tmpSagyoHinmoku.push(s)
        }
      })
      // オプション作業
      this.rows.optionSagyoRows.forEach(function (item) {
        const t = (sendData.trJuchuHinmoku) ? sendData.trJuchuHinmoku.find((x) => x.mstHinmeiId === item.mstHinmeiId) : undefined
        if (t === undefined) {
          tmpJuchuHinmoku.push({
            // trSagyoMeisai
            id: (t === undefined) ? 0 : t.id,
            sagyoHinmokuNo: (t === undefined) ? 0 : t.sagyoHinmokuNo,
            hinmokuSbt: '02',
            mstHinmeiId: item.mstHinmeiId,
            hinmeiBiko: item.hinmeiNm,
            juchuSuryo: item.juchuSuryo,
            // trSagyoMeisaiExtTg
            extId: (t === undefined) ? 0 : t.extId,
            hinban: item.hinban,
            katashiki: item.Katashiki,
            // trSagyoKingaku
            kingakuId: (t === undefined) ? 0 : t.kingakuId,
            kihonUnchin: formatter.removeComma(item.seikyuKingaku),
            userKingakuKazei1: formatter.removeComma(item.shiharaiKingaku)
          })
        } else {
          t.juchuSuryo = item.juchuSuryo
          t.kihonUnchin = formatter.removeComma(item.seikyuKingaku)
          t.userKingakuKazei1 = formatter.removeComma(item.shiharaiKingaku)
          tmpJuchuHinmoku.push(t)
        }
        const s = (sendData.trSagyoHinmoku) ? sendData.trSagyoHinmoku.find((x) => x.mstHinmeiId === item.mstHinmeiId) : undefined
        if (s === undefined) {
          tmpSagyoHinmoku.push({
            // trSagyoMeisai
            id: (s === undefined) ? 0 : s.id,
            sagyoHinmokuNo: (s === undefined) ? 0 : s.sagyoHinmokuNo,
            hinmokuSbt: '02',
            mstHinmeiId: item.mstHinmeiId,
            hinmeiBiko: item.hinmeiNm,
            juchuSuryo: 1,
            // trSagyoMeisaiExtTg
            extId: (s === undefined) ? 0 : s.extId,
            hinban: item.hinban,
            katashiki: item.Katashiki,
            // trSagyoKingaku
            kingakuId: (s === undefined) ? 0 : s.kingakuId,
            kihonUnchin: formatter.removeComma(item.seikyuKingaku),
            userKingakuKazei1: formatter.removeComma(item.shiharaiKingaku)
          })
        } else {
          s.juchuSuryo = item.juchuSuryo
          s.kihonUnchin = formatter.removeComma(item.seikyuKingaku)
          s.userKingakuKazei1 = formatter.removeComma(item.shiharaiKingaku)
          tmpSagyoHinmoku.push(s)
        }
      })
      // 部材
      this.rows.sagyoBuzaiRows.forEach(function (item) {
        const t = (sendData.trJuchuHinmoku) ? sendData.trJuchuHinmoku.find((x) => x.mstHinmeiId === item.mstHinmeiId) : undefined
        if (t === undefined) {
          tmpJuchuHinmoku.push({
            // trSagyoMeisai
            id: (t === undefined) ? 0 : t.id,
            sagyoHinmokuNo: (t === undefined) ? 0 : t.sagyoHinmokuNo,
            hinmokuSbt: item.hinshuSbt,
            mstHinmeiId: item.mstHinmeiId,
            hinmeiBiko: item.hinmeiNm,
            juchuSuryo: 1,
            // trSagyoMeisaiExtTg
            extId: (t === undefined) ? 0 : t.extId,
            hinban: item.hinban,
            katashiki: item.Katashiki,
            // trSagyoKingaku
            kingakuId: (t === undefined) ? 0 : t.kingakuId,
            kihonUnchin: formatter.removeComma(item.seikyuKingaku)
          })
        } else {
          t.juchuSuryo = item.juchuSuryo
          t.kihonUnchin = formatter.removeComma(item.seikyuKingaku)
          tmpJuchuHinmoku.push(t)
        }
        const s = (sendData.trSagyoHinmoku) ? sendData.trSagyoHinmoku.find((x) => x.mstHinmeiId === item.mstHinmeiId) : undefined
        if (s === undefined) {
          tmpSagyoHinmoku.push({
            // trSagyoMeisai
            id: (s === undefined) ? 0 : s.id,
            sagyoHinmokuNo: (s === undefined) ? 0 : s.sagyoHinmokuNo,
            hinmokuSbt: item.hinshuSbt,
            mstHinmeiId: item.mstHinmeiId,
            hinmeiBiko: item.hinmeiNm,
            juchuSuryo: 1,
            // trSagyoMeisaiExtTg
            extId: (s === undefined) ? 0 : s.extId,
            hinban: item.hinban,
            katashiki: item.Katashiki,
            // trSagyoKingaku
            kingakuId: (s === undefined) ? 0 : s.kingakuId,
            kihonUnchin: formatter.removeComma(item.seikyuKingaku)
          })
        } else {
          s.juchuSuryo = item.juchuSuryo
          s.kihonUnchin = formatter.removeComma(item.seikyuKingaku)
          tmpSagyoHinmoku.push(s)
        }
      })

      // 送信情報の品目を置き換え（※選択されたもののみを反映させる為）
      sendData.trJuchuHinmoku = tmpJuchuHinmoku
      sendData.trSagyoHinmoku = tmpSagyoHinmoku

      // --------------------------------------------------------------------------------
      // 車両情報
      // --------------------------------------------------------------------------------
      const sharyoList = []
      this.rows.sharyoRows.forEach(function (item) {
        sharyoList.push({
          // 変更フラグ
          editFlg: (item.editFlg) ? item.editFlg : false,
          // trSagyoMeisai
          id: (item.id) ? item.id : 0,
          sagyoMeisaiNo: (item.sagyoMeisaiNo) ? item.sagyoMeisaiNo : '',
          sagyoEigyoshoId: (item.sagyoEigyoshoId) ? item.sagyoEigyoshoId : null,
          sagyoYoteiYmd: (item.sagyoIraiYmd) ? item.sagyoIraiYmd : null,
          sagyoYmd: (item.sagyoYmd) ? item.sagyoYmd : null,
          hatsuchiYmd: (item.hatsuchiYmd) ? item.hatsuchiYmd : null,
          chakuchiYmd: (item.chakuchiYmd) ? item.chakuchiYmd : null,
          unchinCheckTantoshaId: (item.unchinCheckTantoshaId) ? item.unchinCheckTantoshaId : null,
          unchinCheckYmd: (item.unchinCheckYmd) ? item.unchinCheckYmd : null,
          ryokinCalcFlg1: (item.sagyoKanryoFlg) ? item.sagyoKanryoFlg : false,
          ryokinCalcFlg2: (item.uriageKakuteiFlg) ? item.uriageKakuteiFlg : false,
          denpyoBiko2: item.oldShabanPlateNo,
          keiyuchiId1Biko: item.oldShadaiNo,
          denpyoBiko1: item.newShabanPlateNo,
          denpyoBiko3: item.newShadaiNo,
          denpyoBiko9: item.sharyoKeishiki,
          denpyoBiko10: item.shonendoToroku,
          denpyoHanyoSbt3: item.sharyoMaker,
          denpyoBiko4: item.shashu,
          denpyoHanyoSbt4: item.backeyeKeishiki,
          denpyoBiko5: item.etcKanriNo,
          denpyoHanyoSbt5: item.etcKeishiki,
          denpyoHanyoSbt6: item.refrigeratorMaker,
          denpyoBiko6: item.oldSerialNo,
          denpyoBiko7: item.newSerialNo,
          denpyoBiko8: item.doorNo,
          denpyoHanyoSbt2: item.sagyoSbt,
          denpyoHanyoSbt1: '02',
          delFlg: item.delFlg,
          updDate: (item.updDate) ? item.updDate : '2000/01/01',
          // trSagyoMeisaiExtTg
          extId: (item.trSagyoMeisaiExtTgId) ? item.trSagyoMeisaiExtTgId : 0,
          shohin_id: self.rec.trJuchuMeisai.shohinId,
          Number: item.keyNo,
          uriageKakuteiTantoshaId: (item.uriageKakuteiTantoshaId) ? item.uriageKakuteiTantoshaId : null,
          uriageKakuteiYmd: (item.uriageKakuteiYmd) ? item.uriageKakuteiYmd : null,
          notYayoiRenkeiFlg: (item.notYayoiRenkeiFlg) ? item.notYayoiRenkeiFlg : false,
          matomeSeikyuFlg: (item.matomeSeikyuFlg) ? item.matomeSeikyuFlg : false,
          sagyoMemo: (item.sagyoMemo) ? item.sagyoMemo : null,
          sharyoBiko: (item.sharyoBiko) ? item.sharyoBiko : null,
          addOnWorkFlg: (item.addOnWorkFlg) ? item.addOnWorkFlg : false,
          sagyoCancelFlg: (item.sagyoCancelFlg) ? item.sagyoCancelFlg : false,
          sagyoCancelYmd: (item.sagyoCancelYmd) ? item.sagyoCancelYmd : null,
          iraisakiRenrakuMemo: (item.iraisakiRenrakuMemo) ? item.iraisakiRenrakuMemo : null,
          extDelFlg: item.delFlg,
          extUpdDate: (item.smexUpdDate) ? item.smexUpdDate : null,
          // trSagyoKingaku
          kingakuId: (item.trSagyoKingakuId) ? item.trSagyoKingakuId : 0,
          kingakuDelFlg: item.delFlg,
          KingakuUpdDate: (item.skUpdDate) ? item.skUpdDate : null,

          // trSagyoJisseki
          trSagyoJissekiId: (item.trSagyoJissekiId) ? item.trSagyoJissekiId : null,
          jissekiSagyoYmd: item.jissekiSagyoYmd ? item.jissekiSagyoYmd : null,
          jissekiUpdDate: (item.sjUpdDate) ? item.sjUpdDate : null,
          receiptKingakuId: (item.trSagyoKingakuId2) ? item.trSagyoKingakuId2 : 0,
          receiptKingakuUpdDate: (item.skUpdDate2) ? item.skUpdDate2 : null,
          receiptKingaku: (item.sagyoKeihiKingaku1) ? item.sagyoKeihiKingaku1 : null
        })
      })
      sendData.trSagyoSharyoList = sharyoList

      // const sharyoList = []
      const sharyoHinmokuList = []
      this.rows.sharyoKihonRows.forEach(function (item) {
        sharyoHinmokuList.push({
          // trSagyoHimoku
          id: (item.id) ? item.id : 0,
          trSagyoMeisaiId: (item.trSagyoMeisaiId) ? item.trSagyoMeisaiId : 0,
          sagyoHinmokuNo: (item.sagyoHinmokuNo) ? item.sagyoHinmokuNo : 0,
          hinmokuSbt: '01',
          mstHinmeiId: item.mstHinmeiId,
          hinmeiBiko: item.hinmeiNm,
          juchuSuryo: (item.juchuSuryo) ? item.juchuSuryo : 0,
          updDate: (item.updDate) ? item.updDate : '2000/01/01',
          // trSagyoHinmokuExtTg
          extId: (item.trSagyoHinmokuExtTgId) ? item.trSagyoHinmokuExtTgId : 0,
          himodukeId: (item.himodukeId) ? item.himodukeId : 0,
          hinban: item.hinban,
          katashiki: item.Katashiki,
          extDelFlg: false,
          extUpdDate: (item.shetUpdDate) ? item.shetUpdDate : null,
          // trSagyoKingaku
          kingakuId: (item.trSagyoKingakuId) ? item.trSagyoKingakuId : 0,
          kihonUnchin: item.seikyuKingaku,
          userKingakuKazei1: item.shiharaiKingaku,
          kingakuDelFlg: false,
          kingakuUpdDate: (item.skUpdDate) ? item.skUpdDate : null,
          // 車両マッピングキー
          number: item.keyNo
        })
      })
      this.rows.sharyoOptionRows.forEach(function (item) {
        sharyoHinmokuList.push({
          // trSagyoHimoku
          id: (item.id) ? item.id : 0,
          trSagyoMeisaiId: (item.trSagyoMeisaiId) ? item.trSagyoMeisaiId : 0,
          sagyoHinmokuNo: (item.sagyoHinmokuNo) ? item.sagyoHinmokuNo : 0,
          hinmokuSbt: '02',
          mstHinmeiId: item.mstHinmeiId,
          hinmeiBiko: item.hinmeiNm,
          juchuSuryo: (item.juchuSuryo) ? item.juchuSuryo : 0,
          updDate: (item.updDate) ? item.updDate : '2000/01/01',
          // trSagyoHinmokuExtTg
          extId: (item.trSagyoHinmokuExtTgId) ? item.trSagyoHinmokuExtTgId : 0,
          himodukeId: (item.himodukeId) ? item.himodukeId : 0,
          hinban: item.hinban,
          katashiki: item.Katashiki,
          extDelFlg: false,
          extUpdDate: (item.shetUpdDate) ? item.shetUpdDate : null,
          // trSagyoKingaku
          kingakuId: (item.trSagyoKingakuId) ? item.trSagyoKingakuId : 0,
          kihonUnchin: item.seikyuKingaku,
          userKingakuKazei1: item.shiharaiKingaku,
          kingakuDelFlg: false,
          kingakuUpdDate: (item.skUpdDate) ? item.skUpdDate : null,
          // 車両マッピングキー
          number: item.keyNo
        })
      })
      this.rows.sharyoBuzaiRows.forEach(function (item) {
        sharyoHinmokuList.push({
          // trSagyoHimoku
          id: (item.id) ? item.id : 0,
          trSagyoMeisaiId: (item.trSagyoMeisaiId) ? item.trSagyoMeisaiId : 0,
          sagyoHinmokuNo: (item.sagyoHinmokuNo) ? item.sagyoHinmokuNo : 0,
          hinmokuSbt: item.hinmokuSbt,
          mstHinmeiId: item.mstHinmeiId,
          hinmeiBiko: item.hinmeiNm,
          juchuSuryo: (item.juchuSuryo) ? item.juchuSuryo : 0,
          updDate: (item.updDate) ? item.updDate : '2000/01/01',
          // trSagyoHinmokuExtTg
          extId: (item.trSagyoHinmokuExtTgId) ? item.trSagyoHinmokuExtTgId : 0,
          himodukeId: (item.himodukeId) ? item.himodukeId : 0,
          hinban: item.hinban,
          katashiki: item.Katashiki,
          extDelFlg: false,
          extUpdDate: (item.shetUpdDate) ? item.shetUpdDate : null,
          // trSagyoKingaku
          kingakuId: (item.trSagyoKingakuId) ? item.trSagyoKingakuId : 0,
          kihonUnchin: item.seikyuKingaku,
          userKingakuKazei1: item.shiharaiKingaku,
          kingakuDelFlg: false,
          kingakuUpdDate: (item.skUpdDate) ? item.skUpdDate : null,
          // 車両マッピングキー
          number: item.keyNo
        })
      })
      sendData.trSagyoSharyoHimokuList = sharyoHinmokuList

      const keyId = this.id > 0 ? this.id : -1
      const f = this.HttpClient.put(`/api/v1/Tgrcod0021/Register?id=${keyId}`, sendData)

      return f
    },
    registerValidate: function () {
      if (parseInt(this.mitsumoriIraiDaisu, 10) !== parseInt(this.availableSharyoCount, 10)) {
        modals.showError('依頼台数と作業車両の台数が一致していません<br>依頼台数または作業車両を見直してください')
        return false
      }

      return true
    },

    // 共通
    showMessage: function (data) {
      if (data.summaryMessage && data.summaryMessage.messageCd) {
        modals.showAlert(data.summaryMessage.messageCd).then(() => {})
      }
    },
    showToastMessage: function (data) {
      if (data.summaryMessage && data.summaryMessage.messageCd) {
        modals.showToastMessage(data.summaryMessage.messageCd, null, 2000, 400, null, 'success')
      }
    },
    // 編集中の場合、保存確認後にダイアログを開く
    saveCheckBeforeOpenDialogPromise: function (item) {
      return new Promise((resolve) => {
        if (this.isShoukaiMode) { resolve(true) }
        const created = this.id === 0 || this.juchuKihonId === 0
        const target = this.getCloneTargetMethod()
        const modified = this._compareClone(target)
        const p = created || modified ? modals.showConfirmYesNo : this._dummyPromiseMethod
        if (p === this._dummyPromiseMethod) {
          resolve(true)
        } else {
          const messageCd = created ? 'TGRCOQ03' : 'TGRCOQ01'
          p(messageCd).then((ok) => {
            if (ok === false || ok === undefined) {
              modals.showToast('内容が変更されている為、<br>この操作を実行するには保存が必要です', 1800, 400, 'center', 'warning')
              resolve(false)
            } else {
              this.save(false, false).then((result) => {
                resolve(result)
              })
            }
          })
        }
      })
    },
    // ページ操作
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      if (this.filteredSharyoRows.length === 0) return
      this.vitemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vitemsPerPage, this.vPage)
        this.$refs.pagination2.syncPagination(this.vitemsPerPage, this.vPage)
      })
    },
    changePage: function (e) {
      this.vPage = e
      if (this.filteredSharyoRows.length === 0) return
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vitemsPerPage, this.vPage)
        this.$refs.pagination2.syncPagination(this.vitemsPerPage, this.vPage)
      })
    },
    // ----------------------------------------------------------------------
    // 差分デバッグ用
    _compareClone: function (target) {
      console.log('_compareClone', target, this.cloneData)
      const t1 = JSON.stringify(target.rec)
      const c1 = JSON.stringify(this.cloneData.rec)
      const t2 = JSON.stringify(target.rows)
      const c2 = JSON.stringify(this.cloneData.rows)

      const t211 = JSON.stringify(target.rows.signalItems)
      const c211 = JSON.stringify(this.cloneData.rows.signalItems)
      const t212 = JSON.stringify(target.rows.kihonSagyoRows)
      const c212 = JSON.stringify(this.cloneData.rows.kihonSagyoRows)
      const t213 = JSON.stringify(target.rows.optionSagyoRows)
      const c213 = JSON.stringify(this.cloneData.rows.optionSagyoRows)
      const t214 = JSON.stringify(target.rows.sagyoBuzaiRows)
      const c214 = JSON.stringify(this.cloneData.rows.sagyoBuzaiRows)

      const t221 = JSON.stringify(target.rows.sharyoRows)
      const c221 = JSON.stringify(this.cloneData.rows.sharyoRows)
      const t222 = JSON.stringify(target.rows.sharyoKihonRows)
      const c222 = JSON.stringify(this.cloneData.rows.sharyoKihonRows)
      const t223 = JSON.stringify(target.rows.sharyoOptionRows)
      const c223 = JSON.stringify(this.cloneData.rows.sharyoOptionRows)
      const t224 = JSON.stringify(target.rows.sharyoBuzaiRows)
      const c224 = JSON.stringify(this.cloneData.rows.sharyoBuzaiRows)

      const t231 = JSON.stringify(target.rows.hassoDenpyoRows)
      const c231 = JSON.stringify(this.cloneData.rows.hassoDenpyoRows)
      const t232 = JSON.stringify(target.rows.hassoDenpyoBuzaiRows)
      const c232 = JSON.stringify(this.cloneData.rows.hassoDenpyoBuzaiRows)

      const t24 = JSON.stringify(target.rows.sagyoIraiRows)
      const c24 = JSON.stringify(this.cloneData.rows.sagyoIraiRows)

      const x1 = t1 !== c1
      const x2 = t2 !== c2
      const x211 = t211 !== c211
      const x212 = t212 !== c212
      const x213 = t213 !== c213
      const x214 = t214 !== c214
      const x221 = t221 !== c221
      const x222 = t222 !== c222
      const x223 = t223 !== c223
      const x224 = t224 !== c224
      const x231 = t231 !== c231
      const x232 = t232 !== c232
      const x24 = t24 !== c24

      return x1 || x2 || x211 || x212 || x213 || x214 || x221 || x222 || x223 || x224 || x231 || x232 || x24
    },
    // ----------------------------------------------------------------------
    usableDblClick (item) {
      return 'usable-dblclick'
    },

    dummyfunction () {
      return true
    }
  }
}
